import { GetParameterByName } from "@core/Utils/HelperFunction";

export enum Messages {
	WAITING,
	BETS_OPEN_PLACE_BETS,
	BETS_CLOSING_HURRY,
	NO_MORE_BETS,
	WAITING_WIN_NUMBER,
	DISCONNECTED,
	BET,
	WIN,
	BETS_ARE_CLOSED,
	NOT_ENOUGH_CREDITS,
	LEFT_REDS,
	LEFT_BLACKS,
	RIGHT_REDS,
	RIGHT_BLACKS,
	NEIGBOR_BET,
	TABLE_LAYOUT,
	REPEAT,
	UNDO,
	ZERO_GAME,
	BIG_SERIES,
	ORPHANS,
	SERIE_58,
	FINALI,
	RED_SPLIT,
	BLACK_SPLIT,
	HOT_NUMBERS,
	RED_SNAKE,
	PRISON_BETS,
	MAGIC_RING,
	COLD_NUMBERS,
	TRACK_LAYOUT,
	PRESETS,
	WRONG_BET,
	ERROR_ESTABLISHING_CONNECTION,
	INCOMPATIBLE_BET,
	TO_TABLE_LAYOUT,
	TO_TRACK_LAYOUT,
	CHANGE_TO_BOARD_LAYOUT_TO_BET,
	WINNING_NUMBER_IS,
	TURN_DEVICE_HORIZONTALLY,
	CANNOT_REACH_SERVER_AT,
	BETS_NOT_COMMITED,
	CONNECTING,
	DOUBLE,
	CANNOT_SHOW_HISTORY,
	NO_PLAYED_GAME_HISTORY,
	SHOWING_HISTORY,
	ERROR_MISSING_PARAM,
	GAME_ID,
	PLAYER_ID,
	CASH,
	CREDIT,
	PAINT,
	NORMAL,
	ONE_CREDIT,
	DEMO,
	MALFUNCTION_VOID_WARNING,
	ERROR_ESTABLISHING_CONNECTION_RETRY,
	YOU_HAVE_PLACED_BETS,
	ACCOUNT_ALREADY_CONNECTED,
	ENTER_PIN,
	CLIENT_LOCKED,
	PRESS_LOGOUT_AGAIN_TO_LOGOUT,
	CANNOT_LOGOUT_ACTIVE_GAME,
	WRONG_PASSWORD,
	HOW_TO_ENTER_FULLSCREEN,
	CLICK_TO_CONTINUE,
	ENABLE_SOUNDS,
	YES,
	NO,
	GAMES_AGO,
	AUTHENTICATION_PROBLEM,
	GO_TO_CASHIER,
	FIELD_LIMIT,
	MAX_NUM_CHIPS_REACHED,
	PLAYBOARD_LIMIT_REACHED,
	MAX_BET_LIMIT_REACHED,
	MAX_WIN_LIMIT_REACHED,
	BANNED_TRY_AGAIN,
	NO_GAME_TO_REPEAT,
	CLICK_TO_RESTART_GAME,
	REPEAT_THIS_GAME,
	CANNOT_REPEAT_SELECTED_GAME,
	I_ACCEPT,
	ACCEPT_TERMS_CONDITIONS,
	CLICK_TO_CHAT,
	X_PLAYERS_WON,
	CHANGING_CROUPIER,
	SESSION_TIMED_OUT_RESTART_CLIENT,
	CONNECTION_IS_BAD,
	ANDROID_PRE_FULLSCREEN_MESSAGE,
	DESKTOP_PRE_FULLSCREEN_MESSAGE,
	SET_PIN,
	SET_PIN_SUBTEXT,
	CONFIRM_PIN,
	CONFIRM_PIN_SUBTEXT,
	ENTER_PIN_SUBTEXT,
	PAYOUT_REQUESTED,
	SESSION_EXPIRED,
	DOUBLE_ZERO_GAME,
	MAX_WIN,
	LAST_BET,
	LAST_WIN,
	ZERO_GAME_AND_BIG_SERIES,
	NASSA_AND_BIG_SERIES,
	HISTORY_VIEW_TITLE,
	TRACK_VIEW,
	TABLE_VIEW,
	SHOW_WINS,
	HIDE_WINS,
	HISTORY_WIN,
	HELP_TITLE,
	HELP_PLAYER_INTERFACE,
	HELP_PLAYER_TRACK,
	HELP_PLAYER_INFORMATION,
	HELP_TOP_PANEL,
	HELP_JACKPOT,
	HELP_FIGURES,
	HELP_EXTRAS,
	HELP_FIVE_NUMBERS_TITLE,
	HELP_FIVE_NUMBERS_BODY,
	HELP_FOUR_NUMBERS_TITLE,
	HELP_FOUR_NUMBERS_BODY,
	HELP_TRIO_TITLE,
	HELP_TRIO_BODY,
	HELP_SIX_NUMBERS_TITLE,
	HELP_SIX_NUMBERS_BODY,
	HELP_CORNER_TITLE,
	HELP_CORNER_BODY,
	HELP_SPLIT_TITLE,
	HELP_SPLIT_BODY,
	HELP_STRAIGHT_TITLE,
	HELP_STRAIGHT_BODY,
	HELP_BLACK_RED,
	HELP_1TO12,
	HELP_REPEAT_BODY,
	HELP_UNDO_BODY,
	HELP_BET_PRESETS_BODY,
	HELP_PROGRESS_BAR_BODY,
	HELP_PROGRESS_BAR_TEXT_BODY,
	HELP_BUTTON_PRESETS_BODY,
	HELP_HISTORY_BAR,
	HELP_PLAYER_CREDITS,
	HELP_BETTING_CHIPS,
	HELP_ERASER,
	HELP_PLAYER_NAME_AND_DENOM,
	HELP_DENOMINATION,
	HELP_PAYS,
	HELP_TRACK_FIELD,
	HELP_TRACK_CHEVAL,
	HELP_TRACK_CENTER_PRESETS,
	HELP_TRACK_WIDE_BETS,
	HELP_BETINFO_TITLE,
	HELP_BETINFO_DESCRIPTION,
	HELP_BETINFO_MAIN_DESCRIPTION,
	HELP_BETINFO_CHIPS_DESCRIPTION,
	HELP_BETINFO_LIMITS_TABLE,
	HELP_BETINFO_MIN_BET,
	HELP_BETINFO_MAX_BET,
	HELP_BETINFO_BET_TYPE,
	HELP_BETINFO_BETTYPE_PLAIN,
	HELP_BETINFO_BETTYPE_CAVAL,
	HELP_BETINFO_BETTYPE_TRASV,
	HELP_BETINFO_BETTYPE_CARRE,
	HELP_BETINFO_BETTYPE_FIFTH,
	HELP_BETINFO_BETTYPE_SIXTH,
	HELP_BETINFO_BETTYPE_HLINE,
	HELP_BETINFO_BETTYPE_THIRD,
	HELP_BETINFO_BETTYPE_COLOR,
	HELP_BETINFO_BETTYPE_ODEVN,
	HELP_BETINFO_BETTYPE_PHALF,
	HELP_BETINFO_MIN_TABLE_BET,
	HELP_BETINFO_MAX_TABLE_BET,
	HELP_BETINFO_NO_MIN_TABLE_BET,
	HELP_BETINFO_NO_MAX_TABLE_BET,
	HELP_LAYOUT_BUTTON,
	HELP_DISCONNECTION_POLICY,
	HELP_ERROR_HANDLING,
	HELP_JACKPOT_LEVEL,
	HELP_JACKPOT_MARKER,
	GA_HELP_JACKPOT_LEVEL,
	GA_HELP_JACKPOT_MARKER,
	PAYOUT_BUTTON,
	MENU_HISTORY,
	MENU_STATISTICS,
	MENU_FULLSCREEN,
	MENU_CHAT,
	MENU_VOLUME_SETTINGS,
	SETTINGS_VIDEO_VOLUME,
	SETTINGS_EFFECTS_VOLUME,
	SETTINGS_MUSIC_VOLUME,
	MENU_GRAPHICS_SETTINGS,
	SETTINGS_RENDER,
	MENU_WITHDRAW,
	MENU_LOGOUT,
	MIN_TABLE_BET,
	MAX_TABLE_BET,
	TABLE_NO_MINIMUM,
	TABLE_NO_MAXIMUM,
	BLACK_SNAKE,
	NEIGHBORS,
	SMALL_SERIES,
	ALTERNATIVE_ZERO_GAME, // Alternative because the order of number and word can vary among languages, cannot write 0 + Messages.GAME
	CLEAR,
	CLEAR_ALL,
	START,
	PLACE_BETS_FOR_SHOWING_POTENTIAL_WINS,
	SUCCESSFUL_LOGOUT_THANK_YOU,
	SELECT_STAKE_TO_PLAY,
	CONTINUE_BUTTON,
	GENERIC_GAME, // For usage of the word game standalone
	TRACK_BIG_SERIES,
	HANDPAY_LOCK_INFO_PLAYER_NAME,
	HANDPAY_LOCK_INFO_PLAYER_NICKNAME,
	HANDPAY_LOCK_INFO_STATION_OR_DOMAIN,
	PAYOUT_REQUEST_ARE_YOU_SURE,
	CLICK_TO_CLOSE_HISTORY_VIEW,
	QUESTION_STAKE_DESCRIPTION_SUBTEXT,
	QUESTION_STAKE,
	INTRO_HOW_TO_PLAY,
	INTRO_HOW_TO_PLAY_DESCRIPTION,
	BUTTON_HELP,
	BUTTON_LOCK,
	BUTTON_DENOMINATION,
	CLOSING,
	CLICK_LES_FIGURES,
	CLICK_SIMPLE_SIDEBETS,
	LESFIGURES_NASSA,
	LESFIGURES_TIER,
	LESFIGURES_ORPHELINS,
	LESFIGURES_VOISINS,
	LESFIGURES_COLLECT,
	LESFIGURES_ALLIN,
	HELP_BETINFO_BETTYPE_FIGURE,
	HELP_BETINFO_BETTYPE_TAUTVA,
	HELP_FIGURES_FIGURE_DESCRIPTION,
	HELP_FIGURES_FIGURE_WIN,
	HELP_FIGURES_TOUTVA_DESCRIPTION,
	HELP_FIGURES_TOUTVA_DESCRIPTION_SECONDPART
};

export enum ELanguage {
	ENGLISH = "en",
	SPANISH = "es",
	ITALIAN = "it",
	CROATIAN = "hr",
	GERMAN = "de",
	FRENCH = "fr",
	PORTUGESE = "pt"
};
export class Language {
	static locale = "sl-SI";
	static style = "currency";
	static currency = "USD";
	static PreferredLanguage: ELanguage = ELanguage.ENGLISH;
	static initialized: boolean = false;

	public static init() {
		Language.languages.set(ELanguage.ENGLISH, this.EnglishTranslation);
		Language.languages.set(ELanguage.SPANISH, this.SpanishTranslation);
		Language.languages.set(ELanguage.ITALIAN, this.ItalianTranslation);
		Language.languages.set(ELanguage.CROATIAN, this.CroatianTranslation);
		Language.languages.set(ELanguage.GERMAN, this.DeutschTranslation);
		Language.languages.set(ELanguage.FRENCH, this.FranceTranslation);
		Language.languages.set(ELanguage.PORTUGESE, this.PortugeseTranslation);

		let langCookie = GetParameterByName("locale");
		if (langCookie != "") {
			Language.PreferredLanguage = langCookie.split("_")[0] as any;
		} else {
			Language.PreferredLanguage = ELanguage.ENGLISH;
		}

		this.initialized = true;
	}

	static Get(id: Messages, langId = this.PreferredLanguage): string {
		if (!this.initialized)
			this.init();

		if (this.languages.get(langId) && this.languages.get(langId).has(id)) {//try to get translation
			return this.languages.get(langId).get(id);
		}
		else if (this.languages.get(ELanguage.ENGLISH).has(id)) {//else try to get english (default) translation
			return this.languages.get(ELanguage.ENGLISH).get(id);
		}
		else {
			try {
				let string = id.toString();	//return what we got as string
				return string;
			}
			catch (e) {
				return "";	//its something underfined or null ? how did that get here ? return blank
			}
		}
	}

	public static AddLanguage(languageID: ELanguage, translations: Map<Messages, string>): void {
		Language.languages.set(languageID, translations)
	}


	static InternationalNumberFormat = new Intl.NumberFormat(Language.locale, {
		style: Language.style,
		currency: Language.currency
	})

	/**
	 * MUST BE CALLED EACH TIME WE CHANGE locale, style, currency PROPERTIES
	 */
	static UpdateInternationalNumberFormat(): void {
		try {
			this.InternationalNumberFormat = new Intl.NumberFormat(Language.locale, {
				style: Language.style,
				currency: Language.currency
			})
		}
		catch (e) {//fallback
			this.InternationalNumberFormat = new Intl.NumberFormat("sl-SI", {
				style: "decimal",
			})
		}
	}

	private static languages: Map<ELanguage, Map<Messages, string>> = new Map<ELanguage, Map<Messages, string>>();

	private static EnglishTranslation: Map<Messages, string> = new Map<Messages, string>([
		[Messages.WAITING, "Waiting..."],
		[Messages.BETS_OPEN_PLACE_BETS, "Bets are open, place your bets"],
		[Messages.BETS_CLOSING_HURRY, "Bets are closing, hurry up!"],
		[Messages.NO_MORE_BETS, "No more bets"],
		[Messages.WAITING_WIN_NUMBER, "Waiting for win number..."],
		[Messages.DISCONNECTED, "Disconnected, reconnecting..."],
		[Messages.BET, "Bet"],
		[Messages.WIN, "Last Win"],
		[Messages.BETS_ARE_CLOSED, "Wait for next game."],
		[Messages.NOT_ENOUGH_CREDITS, "You do not have enough credits."],
		[Messages.MAX_NUM_CHIPS_REACHED, "Maximum number of chips reached!"],
		[Messages.PLAYBOARD_LIMIT_REACHED, "Playboard limit reached!"],
		[Messages.MAX_WIN_LIMIT_REACHED, "Max win limit reached!"],
		[Messages.MAX_BET_LIMIT_REACHED, "Max bet limit reached!"],
		[Messages.LEFT_REDS, "LEFT REDS"],
		[Messages.LEFT_BLACKS, "LEFT BLACKS"],
		[Messages.RIGHT_REDS, "RIGHT REDS"],
		[Messages.RIGHT_BLACKS, "RIGHT BLACKS"],
		[Messages.NEIGBOR_BET, "NEIGHBOR BET"],
		[Messages.TABLE_LAYOUT, "TABLE LAYOUT"],
		[Messages.REPEAT, "REPEAT"],
		[Messages.UNDO, "UNDO"],
		[Messages.ZERO_GAME, "ZERO GAME"],
		[Messages.BIG_SERIES, "BIG SERIES"],
		[Messages.ORPHANS, "ORPHANS"],
		[Messages.SERIE_58, "SERIE 5/8"],
		[Messages.FINALI, "FINALI"],
		[Messages.RED_SPLIT, "RED SPLIT"],
		[Messages.BLACK_SPLIT, "BLACK SPLIT"],
		[Messages.HOT_NUMBERS, "HOT NUMBERS"],
		[Messages.RED_SNAKE, "RED SNAKE"],
		[Messages.PRISON_BETS, "PRISON BETS"],
		[Messages.MAGIC_RING, "MAGIC RING"],
		[Messages.COLD_NUMBERS, "COLD NUMBERS"],
		[Messages.TRACK_LAYOUT, "TRACK LAYOUT"],
		[Messages.PRESETS, "BET PRESETS"],
		[Messages.WRONG_BET, "Wrong bet"],
		[Messages.ERROR_ESTABLISHING_CONNECTION, "Error establishing connection to the server!"],
		[Messages.INCOMPATIBLE_BET, "Incompatible bet, cannot change to "],
		[Messages.TO_TABLE_LAYOUT, "table layout."],
		[Messages.TO_TRACK_LAYOUT, "track layout."],
		[Messages.CHANGE_TO_BOARD_LAYOUT_TO_BET, "Please change to board layout to perform bet."],
		[Messages.WINNING_NUMBER_IS, "The winning number is "],
		[Messages.TURN_DEVICE_HORIZONTALLY, "Please turn the device horizontally!"],
		[Messages.CANNOT_REACH_SERVER_AT, "Cannot reach server at "],
		[Messages.BANNED_TRY_AGAIN, "Cannot connect right now. Try again in a minute!"],
		[Messages.BETS_NOT_COMMITED, "Bets were not commited on time!"],
		[Messages.CONNECTING, "Connecting..."],
		[Messages.DOUBLE, "DOUBLE"],
		[Messages.CANNOT_SHOW_HISTORY, "Cannot show history in an active game!"],
		[Messages.NO_PLAYED_GAME_HISTORY, "No played game to be shown as history!"],
		[Messages.SHOWING_HISTORY, "Showing game history:"],
		[Messages.ERROR_MISSING_PARAM, "ERROR: Missing parameter(s)!"],
		[Messages.GAME_ID, "Game ID"],
		[Messages.PLAYER_ID, "Player ID"],
		[Messages.CASH, "Cash"],
		[Messages.CREDIT, "Credit"],
		[Messages.PAINT, "PAINT"],
		[Messages.NORMAL, "NORMAL"],
		[Messages.ONE_CREDIT, "1 credit"],
		[Messages.DEMO, "DEMO"],
		[Messages.MALFUNCTION_VOID_WARNING, "Malfunction voids all plays and pays!"],
		[Messages.ERROR_ESTABLISHING_CONNECTION_RETRY, "Error establishing connection! Retrying..."],
		[Messages.YOU_HAVE_PLACED_BETS, "You have placed bets!"],
		[Messages.ACCOUNT_ALREADY_CONNECTED, "Account already connected! Retrying..."],
		[Messages.ENTER_PIN, "ENTER YOUR PIN"],
		[Messages.CLIENT_LOCKED, "CLIENT LOCKED"],
		[Messages.PRESS_LOGOUT_AGAIN_TO_LOGOUT, "Press logout button again to confirm logout"],
		[Messages.CANNOT_LOGOUT_ACTIVE_GAME, "Cannot logout in an active game!"],
		[Messages.WRONG_PASSWORD, "Wrong password!"],
		[Messages.HOW_TO_ENTER_FULLSCREEN, "How to enter fullscreen:"],
		[Messages.CLICK_TO_CONTINUE, "Click anywhere to continue"],
		[Messages.ENABLE_SOUNDS, "Play sounds?"],
		[Messages.YES, "Yes"],
		[Messages.NO, "No"],
		[Messages.GAMES_AGO, "played games ago"],
		[Messages.AUTHENTICATION_PROBLEM, "Authentication problem"],
		[Messages.GO_TO_CASHIER, "Go to cashier for payout..."],
		[Messages.FIELD_LIMIT, "Field limit reached!"],
		[Messages.NO_GAME_TO_REPEAT, "No played game to repeat!"],
		[Messages.CLICK_TO_RESTART_GAME, "CLICK HERE TO RESTART THE GAME"],
		[Messages.REPEAT_THIS_GAME, "REPEAT SELECTED"],
		[Messages.CANNOT_REPEAT_SELECTED_GAME, "Cannot repeat selected game!"],
		[Messages.I_ACCEPT, "I accept"],
		[Messages.ACCEPT_TERMS_CONDITIONS, "By playing this game you accept our terms and conditions"],
		[Messages.CLICK_TO_CHAT, "CLICK TO CHAT"],
		[Messages.X_PLAYERS_WON, "WON"],
		[Messages.CHANGING_CROUPIER, "Changing croupier, thank you for playing!"],
		[Messages.SESSION_TIMED_OUT_RESTART_CLIENT, "Your session has ended due to inactivity,\n please restart the game to continue playing!"],
		[Messages.CONNECTION_IS_BAD, "YOUR INTERNET CONNECTION IS BAD"],
		[Messages.ANDROID_PRE_FULLSCREEN_MESSAGE, "PRESS OK TO ENTER FULLSCREEN"],
		[Messages.DESKTOP_PRE_FULLSCREEN_MESSAGE, "PLAY IN FULLSCREEN MODE?"],
		[Messages.SET_PIN, "SET YOUR PIN CODE"],
		[Messages.SET_PIN_SUBTEXT, "You'll be promped to enter PIN at payout."],
		[Messages.CONFIRM_PIN, "CONFIRM PIN"],
		[Messages.CONFIRM_PIN_SUBTEXT, "Please re-enter your PIN."],
		[Messages.ENTER_PIN_SUBTEXT, "Please enter your authentication PIN."],
		[Messages.PAYOUT_REQUESTED, "PAYOUT REQUESTED"],
		[Messages.SESSION_EXPIRED, "Your session has expired,\n please restart the game!"],
		[Messages.DOUBLE_ZERO_GAME, "DOUBLE ZERO GAME"],
		[Messages.MAX_WIN, "MAX WIN"],
		[Messages.LAST_BET, "LAST BET"],
		[Messages.LAST_WIN, "LAST WIN"],
		[Messages.ZERO_GAME_AND_BIG_SERIES, "ZERO GAME / BIG SERIES"],
		[Messages.NASSA_AND_BIG_SERIES, "NASSA / BIG SERIES"],
		[Messages.HISTORY_VIEW_TITLE, "HISTORY VIEW"],
		[Messages.TRACK_VIEW, "TRACK\nVIEW"],
		[Messages.TABLE_VIEW, "TABLE\nVIEW"],
		[Messages.SHOW_WINS, "Show Wins"],
		[Messages.HIDE_WINS, "Hide Wins"],
		[Messages.HISTORY_WIN, "Win"],
		[Messages.HELP_TITLE, "HELP"],
		[Messages.HELP_PLAYER_INTERFACE, "Player Interface"],
		[Messages.HELP_PLAYER_TRACK, "Player Track"],
		[Messages.HELP_PLAYER_INFORMATION, "Player Information"],
		[Messages.HELP_TOP_PANEL, "Panels"],
		[Messages.HELP_JACKPOT, "Jackpot"],
		[Messages.HELP_FIGURES, "Figures"],
		[Messages.HELP_EXTRAS, "Extras"],
		[Messages.HELP_FIVE_NUMBERS_TITLE, "FIVE NUMBERS"],
		[Messages.HELP_FIVE_NUMBERS_BODY, "The winning number is any of the five covered."],
		[Messages.HELP_FOUR_NUMBERS_TITLE, "FOUR NUMBERS"],
		[Messages.HELP_FOUR_NUMBERS_BODY, "The winning number is any of the four covered."],
		[Messages.HELP_TRIO_TITLE, "TRIO"],
		[Messages.HELP_TRIO_BODY, "The winning number is any of the three covered."],
		[Messages.HELP_SIX_NUMBERS_TITLE, "SIX NUMBERS"],
		[Messages.HELP_SIX_NUMBERS_BODY, "The winning number is any of the six covered."],
		[Messages.HELP_CORNER_TITLE, "CORNER"],
		[Messages.HELP_CORNER_BODY, "The winning number is any of the four covered."],
		[Messages.HELP_SPLIT_TITLE, "SPLIT"],
		[Messages.HELP_SPLIT_BODY, "The winning number is any of the two covered."],
		[Messages.HELP_STRAIGHT_TITLE, "STRAIGHT UP"],
		[Messages.HELP_STRAIGHT_BODY, "The winning number is only the one covered."],
		[Messages.HELP_BLACK_RED, "Fields 1-18, PAR, RED, BLACK, IMPAR, 19-36 allow you to bet on all of the respective numbers."],
		[Messages.HELP_1TO12, "Vertical and horizontal thirds cover numbers in their respective rows and columns."],
		[Messages.HELP_REPEAT_BODY, "You can repeat bets from your last game by pressing REPEAT when your table is empty."],
		[Messages.HELP_UNDO_BODY, "By pressing UNDO, you can go back by one step. For example, you can undo your last bet."],
		[Messages.HELP_BET_PRESETS_BODY, "By pressing BET PRESETS, you get a wide selection of custom bets."],
		[Messages.HELP_PROGRESS_BAR_BODY, "Time left until closing bets. The time bar will show you the time of the closing bets."],
		[Messages.HELP_PROGRESS_BAR_TEXT_BODY, "Game status message. When you play, different messages will show you the status of the game."],
		[Messages.HELP_BUTTON_PRESETS_BODY, "Very popular predefined bets:\n”ZERO GAME” - place bets to cover zero neighbour numbers in a narrow range, the series is: 12, 35, 3, 26, 0, 32, 15.\n”BIG SERIES” - place bets to cover zero neighbour numbers, the series is 0, 2, 19, 21, 22, 25, 3, 4, 26, 28, 29, 32, 35, 7, 12, 15, 18.\n”ORPHANS” - this bet features numbers, which belong neither to ”SERIE 5/8”, nor to ”BIG SERIES”, the series is: 14, 17, 20, 31, 34, 6, 9, 1.\n”SERIE 5/8” - this bet features the 12 numbers located on the opposite side of the single-zero wheel, the series is: 27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33."],
		[Messages.HELP_HISTORY_BAR, "Win number history from left to right."],
		[Messages.HELP_PLAYER_CREDITS, "Player balance display with bet and last win amounts. By pressing it, you can toggle between money and credit values."],
		[Messages.HELP_BETTING_CHIPS, "Playing chips."],
		[Messages.HELP_ERASER, "Use the eraser to remove placed chips. Tap three times to remove all placed chips."],
		[Messages.HELP_PLAYER_NAME_AND_DENOM, "Player name and denomination."],
		[Messages.HELP_DENOMINATION, "Denomination."],
		[Messages.HELP_PAYS, "pays"],
		[Messages.HELP_TRACK_FIELD, "Press each number on the race track to bet on that number with the selected chip value."],
		[Messages.HELP_TRACK_CHEVAL, "Press on cheval button between numbers, to place a split bet on both neighbor numbers."],
		[Messages.HELP_TRACK_CENTER_PRESETS, "Popular predefined bets are now available in the center of the racetrack."],
		[Messages.HELP_TRACK_WIDE_BETS, "By choosing + 0, + 1, + 2, + 4 it is possible to set the coverage of the bets. Where +0 means only the selected bet, +1 covers the selected bet and one field to the left and one to the right, +2 two more fields to the left to the right, and +4 covers four fields in width."],
		[Messages.HELP_BETINFO_TITLE, "Bets"],
		[Messages.HELP_BETINFO_DESCRIPTION, "Below is the table of current limits per bet type. Values listed are in credits!"],
		[Messages.HELP_BETINFO_MAIN_DESCRIPTION, ""],
		[Messages.HELP_BETINFO_CHIPS_DESCRIPTION, "Chip values for the currently selected stake"],
		[Messages.HELP_BETINFO_LIMITS_TABLE, "Table of limits"],
		[Messages.HELP_BETINFO_MIN_BET, "Min bet"],
		[Messages.HELP_BETINFO_MAX_BET, "Max bet"],
		[Messages.HELP_BETINFO_BET_TYPE, "Bet type"],
		[Messages.HELP_BETINFO_BETTYPE_PLAIN, "Straight up"],
		[Messages.HELP_BETINFO_BETTYPE_CAVAL, "Split"],
		[Messages.HELP_BETINFO_BETTYPE_TRASV, "Trio"],
		[Messages.HELP_BETINFO_BETTYPE_CARRE, "Corner"],
		[Messages.HELP_BETINFO_BETTYPE_FIFTH, "Five numbers"],
		[Messages.HELP_BETINFO_BETTYPE_SIXTH, "Six numbers"],
		[Messages.HELP_BETINFO_BETTYPE_HLINE, "Horizontal line"],
		[Messages.HELP_BETINFO_BETTYPE_THIRD, "Third"],
		[Messages.HELP_BETINFO_BETTYPE_COLOR, "Red / Black"],
		[Messages.HELP_BETINFO_BETTYPE_ODEVN, "Odd / Even"],
		[Messages.HELP_BETINFO_BETTYPE_PHALF, "Half"],
		[Messages.HELP_BETINFO_MIN_TABLE_BET, "Min table bet is"],
		[Messages.HELP_BETINFO_MAX_TABLE_BET, "Max table bet is"],
		[Messages.HELP_BETINFO_NO_MIN_TABLE_BET, "Table has no minimum bet"],
		[Messages.HELP_BETINFO_NO_MAX_TABLE_BET, "Table has no maximum bet"],
		[Messages.HELP_LAYOUT_BUTTON, "Switch between board and racetrack view by pressing the layout button."],
		[Messages.HELP_DISCONNECTION_POLICY, "If you are disconnected from a game round, any placed bets remain valid and are settled in your absence. Upon reconnecting, you can view bet outcomes with the history button."],
		[Messages.HELP_ERROR_HANDLING, "If there is an error in the game, system or game procedure, the game round will be temporarily paused. You and other players will be notified via in-game chat or by an on-screen pop-up message, that the issue is being investigated. If the manager can immediately resolve the error, the game round will continue as normal. If immediate resolution is not possible, the game round will be cancelled, and initial bets will be refunded to all players who participated in the game round."],
		[Messages.HELP_JACKPOT_LEVEL, "Jackpot display shows all available jackpot levels and pot values. If a game is eligible for jackpot, jackpot display will only show the active level."],
		[Messages.HELP_JACKPOT_MARKER, "When a selected jackpot number is revealed, it will be marked on the playboard."],
		[Messages.GA_HELP_JACKPOT_LEVEL, "Jackpot display shows all available jackpot levels and pot values. If a game is eligible for jackpot, the specific jackpot level will start to shine."],
		[Messages.GA_HELP_JACKPOT_MARKER, "When a selected jackpot number is revealed, it will be marked inside the lucky number display."],
		[Messages.PAYOUT_BUTTON, "Payout"],
		[Messages.MENU_HISTORY, "History"],
		[Messages.MENU_STATISTICS, "Statistics"],
		[Messages.MENU_FULLSCREEN, "Full screen"],
		[Messages.MENU_CHAT, "Chat"],
		[Messages.MENU_VOLUME_SETTINGS, "Volume settings"],
		[Messages.MENU_GRAPHICS_SETTINGS, "Graphics settings"],
		[Messages.MENU_WITHDRAW, "Withdraw"],
		[Messages.MENU_LOGOUT, "Logout"],
		[Messages.SETTINGS_MUSIC_VOLUME, "Music volume"],
		[Messages.SETTINGS_EFFECTS_VOLUME, "Effects volume"],
		[Messages.SETTINGS_VIDEO_VOLUME, "Video volume"],
		[Messages.SETTINGS_RENDER, "Render quality"],
		[Messages.MIN_TABLE_BET, "Min bet"],
		[Messages.MAX_TABLE_BET, "Max bet"],
		[Messages.TABLE_NO_MAXIMUM, "No max limit"],
		[Messages.TABLE_NO_MINIMUM, "No min limit"],
		[Messages.BLACK_SNAKE, "BLACK SNAKE"],
		[Messages.NEIGHBORS, "NEIGHBORS"],
		[Messages.SMALL_SERIES, "SMALL SERIES"],
		[Messages.ALTERNATIVE_ZERO_GAME, "0 GAME"],
		[Messages.CLEAR, "CLEAR"],
		[Messages.CLEAR_ALL, "CLEAR ALL?"],
		[Messages.START, "START"],
		[Messages.PLACE_BETS_FOR_SHOWING_POTENTIAL_WINS, "Place some bets to show potential wins"],
		[Messages.SUCCESSFUL_LOGOUT_THANK_YOU, "Successfully logged out. Thank you for playing!"],
		[Messages.SELECT_STAKE_TO_PLAY, "Select the stake you want to play with"],
		[Messages.CONTINUE_BUTTON, "Continue"],
		[Messages.GENERIC_GAME, "GAME"],
		[Messages.TRACK_BIG_SERIES, "BIG SERIES"],
		[Messages.HANDPAY_LOCK_INFO_PLAYER_NAME, "Player name"],
		[Messages.HANDPAY_LOCK_INFO_PLAYER_NICKNAME, "Player nickname"],
		[Messages.HANDPAY_LOCK_INFO_STATION_OR_DOMAIN, "At station"],
		[Messages.PAYOUT_REQUEST_ARE_YOU_SURE, "Are you sure you want\nto request the payout of"],
		[Messages.CLICK_TO_CLOSE_HISTORY_VIEW, "Click anywhere to close history view"],
		[Messages.QUESTION_STAKE_DESCRIPTION_SUBTEXT, "limits for straight\nup bets"],
		[Messages.QUESTION_STAKE, "Stake"],
		[Messages.INTRO_HOW_TO_PLAY, "How to play:"],
		[Messages.INTRO_HOW_TO_PLAY_DESCRIPTION, "Select your betting chip by clicking, place it by clicking again on desired fields."],
		[Messages.BUTTON_HELP, "HELP"],
		[Messages.BUTTON_LOCK, "LOCK"],
		[Messages.BUTTON_DENOMINATION, "DENOM."],
		[Messages.CLOSING, "Closing game.."],
		[Messages.CLICK_LES_FIGURES, "CLICK LES FIGURES"],
		[Messages.CLICK_SIMPLE_SIDEBETS, "CLICK SIDEBETS"],
		[Messages.LESFIGURES_NASSA, "NASSA"],
		[Messages.LESFIGURES_ORPHELINS, "ORPHELINS"],
		[Messages.LESFIGURES_TIER, "TIER"],
		[Messages.LESFIGURES_VOISINS, "VOISINS"],
		[Messages.LESFIGURES_COLLECT, "COLLECT"],
		[Messages.LESFIGURES_ALLIN, "ACTIVATE\nALL IN"],
		[Messages.HELP_BETINFO_BETTYPE_FIGURE, "Figure"],
		[Messages.HELP_BETINFO_BETTYPE_TAUTVA, "All In"],
		[Messages.HELP_FIGURES_FIGURE_DESCRIPTION, "Inside each figure there are numbers the sidebet covers.\n\n\"Figure 1\" covers: 1,10,19 and 28.\n\"Figure 2\" covers: 2,11,20 and 29.\n\"Figure 3\" covers: 3,12,21 and 30.\n\"Figure 4\" covers: 4,13,22 and 31.\n\"Figure 5\" covers: 5,14,23 and 32.\n\"Figure 6\" covers: 6,15,24 and 33.\n\"Figure 7\" covers: 7,16,25 and 34.\n\"Figure 8\" covers: 8,17,26 and 35.\n\"Figure 9\" covers: 9,18,27 and 36."],
		[Messages.HELP_FIGURES_FIGURE_WIN, "In case of a winning hand on the figures sidebets, players can choose between collecting the winning bet or activate the game option \"All In\". In the game \"All In\", the chips are moved to the upper box of the last winning figure. Upon inaction collect is automatically selected."],
		[Messages.HELP_FIGURES_TOUTVA_DESCRIPTION, "If the \"All In\" bet is still winning it will pay "],
		[Messages.HELP_FIGURES_TOUTVA_DESCRIPTION_SECONDPART, " - the player will win extra chips compared to regular figures bet that pays "],
	]);
	private static SpanishTranslation: Map<Messages, string> = new Map<Messages, string>([
		[Messages.WAITING, "Espera..."],
		[Messages.BETS_OPEN_PLACE_BETS, "Las apuestas estan abiertas, coloque sus apuestas."],
		[Messages.BETS_CLOSING_HURRY, "Las apuestas estan cerrandose."],
		[Messages.NO_MORE_BETS, "Las apuestas estan cerradas."],
		[Messages.WAITING_WIN_NUMBER, "Esperando numero de ganadores..."],
		[Messages.DISCONNECTED, "Desconectado, reconectando..."],
		[Messages.BET, "Apuesta"],
		[Messages.WIN, "Ult. ganador"],
		[Messages.BETS_ARE_CLOSED, "Esperando para un nuevo juego."],
		[Messages.NOT_ENOUGH_CREDITS, "No tienes suficientes credito."],
		[Messages.MAX_NUM_CHIPS_REACHED, "Número máximo de fichas alcanzado!"],
		[Messages.PLAYBOARD_LIMIT_REACHED, "¡Límite de tablero de juego alcanzado!"],
		[Messages.MAX_WIN_LIMIT_REACHED, "¡Límite máximo de ganancias alcanzado!"],
		[Messages.MAX_BET_LIMIT_REACHED, "¡Límite máximo de apuesta alcanzado!"],
		[Messages.LEFT_REDS, "ROJOS IZQUIERDA"],
		[Messages.LEFT_BLACKS, "NEGROS IZQUIERDA"],
		[Messages.RIGHT_REDS, "ROJOS DERECHA"],
		[Messages.RIGHT_BLACKS, "NEGROS DERECHA"],
		[Messages.NEIGBOR_BET, "VECINOS"],
		[Messages.TABLE_LAYOUT, "DISENO TABLA"],
		[Messages.REPEAT, "REPETIR"],
		[Messages.UNDO, "DESHACER"],
		[Messages.ZERO_GAME, "JUGAR AL CERO"],
		[Messages.BIG_SERIES, "GRAND SERIE"],
		[Messages.ORPHANS, "HUÉRFANOS"],
		[Messages.SERIE_58, "SERIE 5/8"],
		[Messages.FINALI, "FINALI"],
		[Messages.RED_SPLIT, "CABALLOS ROJOS"],
		[Messages.BLACK_SPLIT, "CABALLOS NEGROS"],
		[Messages.HOT_NUMBERS, "NUMEROS CALIENTES"],
		[Messages.RED_SNAKE, "CULEBRA ROJA"],
		[Messages.PRISON_BETS, "APUESTAS PRISONES"],
		[Messages.MAGIC_RING, "ANILLO MAGICO"],
		[Messages.COLD_NUMBERS, "NUMEROS FRIOS"],
		[Messages.TRACK_LAYOUT, "DISENO PISTA"],
		[Messages.PRESETS, "APUESTA DEFINIDAS"],
		[Messages.WRONG_BET, "Apuesta Equivocada"],
		[Messages.ERROR_ESTABLISHING_CONNECTION, "Error al establecer la conexión con el servidor!"],
		[Messages.INCOMPATIBLE_BET, "Apuesta incompatible, no se puede cambiar a "],
		[Messages.TO_TABLE_LAYOUT, "diseno tabla."],
		[Messages.TO_TRACK_LAYOUT, "diseno pista."],
		[Messages.CHANGE_TO_BOARD_LAYOUT_TO_BET, "Cambie al diseno tabla para realizar la apuesta."],
		[Messages.WINNING_NUMBER_IS, "El numero ganador es "],
		[Messages.TURN_DEVICE_HORIZONTALLY, "Gire el dispositivo horizontalmente!"],
		[Messages.CANNOT_REACH_SERVER_AT, "No se puede llegar al servidor en "],
		[Messages.BANNED_TRY_AGAIN, "No se puede conectar en este momento. Vuelve a intentarlo en un minuto!"],
		[Messages.BETS_NOT_COMMITED, "Las apuestas no se comprometieron a tiempo!"],
		[Messages.CONNECTING, "Conectando..."],
		[Messages.DOUBLE, "DOBLE"],
		[Messages.CANNOT_SHOW_HISTORY, "No se puede mostrar el historial en un juego activo!"],
		[Messages.NO_PLAYED_GAME_HISTORY, "Ningun juego jugado se mostrará como historia! "],
		[Messages.SHOWING_HISTORY, "Mostrando el historial del juego:"],
		[Messages.ERROR_MISSING_PARAM, "ERROR: Faltan parámetros!"],
		[Messages.GAME_ID, "ID del juego"],
		[Messages.PLAYER_ID, "ID del jugador"],
		[Messages.CASH, "Dinero"],
		[Messages.CREDIT, "Credito"],
		[Messages.PAINT, "PINTURA"],
		[Messages.NORMAL, "NORMAL"],
		[Messages.ONE_CREDIT, "1 credito"],
		[Messages.DEMO, "DEMO"],
		[Messages.MALFUNCTION_VOID_WARNING, "Mal funcionamiento, se cancelan todos los juegos y pagos!"],
		[Messages.ERROR_ESTABLISHING_CONNECTION_RETRY, "Error al establecer la conexión! Reintentando..."],
		[Messages.YOU_HAVE_PLACED_BETS, "Has hecho apuestas!"],
		[Messages.ACCOUNT_ALREADY_CONNECTED, "Cuenta ya conectada! Reintentando..."],
		[Messages.ENTER_PIN, "INTRODUCE TU PIN"],
		[Messages.CLIENT_LOCKED, "CLIENTE BLOQUEADO"],
		[Messages.PRESS_LOGOUT_AGAIN_TO_LOGOUT, "Presione el botón de cierre de sesión nuevamente para confirmar el cierre de sesión"],
		[Messages.CANNOT_LOGOUT_ACTIVE_GAME, "No puedo cerrar sesión en un juego activo!"],
		[Messages.WRONG_PASSWORD, "Contraseña incorrecta!"],
		[Messages.HOW_TO_ENTER_FULLSCREEN, "Como entrar a pantalla completa:"],
		[Messages.CLICK_TO_CONTINUE, "Haga clic en cualquier lugar para continuar"],
		[Messages.ENABLE_SOUNDS, "Reproducir sonidos?"],
		[Messages.YES, "Sí"],
		[Messages.NO, "No"],
		[Messages.GAMES_AGO, "juegos jugados hace"],
		[Messages.AUTHENTICATION_PROBLEM, "Problema de autenticacion"],
		[Messages.GO_TO_CASHIER, "Ir al cajero para el pago..."],
		[Messages.FIELD_LIMIT, "Límite de campo alcanzado!"],
		[Messages.NO_GAME_TO_REPEAT, "No hay juego jugado para repetir!"],
		[Messages.CLICK_TO_RESTART_GAME, "HAGA CLIC AQUÍ PARA REINICIAR EL JUEGO"],
		[Messages.REPEAT_THIS_GAME, "REPETIR SELECCIONADO"],
		[Messages.CANNOT_REPEAT_SELECTED_GAME, "No se puede repetir el juego seleccionado!"],
		[Messages.I_ACCEPT, "Acepto"],
		[Messages.ACCEPT_TERMS_CONDITIONS, "Al jugar este juego aceptas nuestros términos y condiciones"],
		[Messages.CLICK_TO_CHAT, "HAGA CLIC PARA CHARLAR"],
		[Messages.X_PLAYERS_WON, "GANADO"],
		[Messages.CHANGING_CROUPIER, "Cambio de crupier, gracias por jugar!"],
		[Messages.SESSION_TIMED_OUT_RESTART_CLIENT, "Su sesión ha finalizado debido a la inactividad,\n reinicie el juego para continuar jugando!"],
		[Messages.CONNECTION_IS_BAD, "SU CONEXIÓN A INTERNET ES BAD"],
		[Messages.ANDROID_PRE_FULLSCREEN_MESSAGE, "PRESIONE OK PARA ENTRAR EN PANTALLA COMPLETA"],
		[Messages.DESKTOP_PRE_FULLSCREEN_MESSAGE, "JUGAR EN MODO DE PANTALLA COMPLETA?"],
		[Messages.SET_PIN, "ESTABLECE TU CÓDIGO PIN"],
		[Messages.SET_PIN_SUBTEXT, "Se le pedirá que ingrese el PIN en el momento del pago."],
		[Messages.CONFIRM_PIN, "CONFIRMAR PIN"],
		[Messages.CONFIRM_PIN_SUBTEXT, "Vuelva a introducir su PIN."],
		[Messages.ENTER_PIN_SUBTEXT, "Por favor ingrese su PIN de autenticación."],
		[Messages.PAYOUT_REQUESTED, "PAGO SOLICITADO"],
		[Messages.SESSION_EXPIRED, "Su sesión ha expirado,\n por favor reinicie el juego!"],
		[Messages.DOUBLE_ZERO_GAME, "DOBLE CERO JUGADA"],
		[Messages.MAX_WIN, "MAX PREMIO"],
		[Messages.LAST_BET, "ULTIMA APUESTA"],
		[Messages.LAST_WIN, "ULTIMO PREMIO"],
		[Messages.ZERO_GAME_AND_BIG_SERIES, "JUGAR AL CERO / GRAND SERIE"],
		[Messages.NASSA_AND_BIG_SERIES, "NASSA / GRAND SERIE"],
		[Messages.HISTORY_VIEW_TITLE, "VISTA DEL HISTORIAL"],
		[Messages.TRACK_VIEW, "DISENO\nPISTA"],
		[Messages.TABLE_VIEW, "DISENO\nTABLA"],
		[Messages.SHOW_WINS, "Indica Premios"],
		[Messages.HIDE_WINS, "Ocular Premios"],
		[Messages.HISTORY_WIN, "Premio"],
		[Messages.HELP_TITLE, "AYUDA"],
		[Messages.HELP_PLAYER_INTERFACE, "Interfaz del jugador"],
		[Messages.HELP_PLAYER_TRACK, "Pista de jugador"],
		[Messages.HELP_PLAYER_INFORMATION, "Información del jugador"],
		[Messages.HELP_TOP_PANEL, "Panel superior"],
		[Messages.HELP_JACKPOT, "Jackpot"],
		[Messages.HELP_FIGURES, "Figures"],
		[Messages.HELP_EXTRAS, "Extras"],
		[Messages.HELP_FIVE_NUMBERS_TITLE, "CINCO NÚMEROS"],
		[Messages.HELP_FIVE_NUMBERS_BODY, "El número ganador es cualquiera de los cinco cubiertos."],
		[Messages.HELP_FOUR_NUMBERS_TITLE, "CUATRO NÚMEROS"],
		[Messages.HELP_FOUR_NUMBERS_BODY, "El número ganador es cualquiera de los cuatro cubiertos."],
		[Messages.HELP_TRIO_TITLE, "TRÍO"],
		[Messages.HELP_TRIO_BODY, "El número ganador es cualquiera de los tres cubiertos."],
		[Messages.HELP_SIX_NUMBERS_TITLE, "SEIS NÚMEROS"],
		[Messages.HELP_SIX_NUMBERS_BODY, "El número ganador es cualquiera de los seis incluidos."],
		[Messages.HELP_CORNER_TITLE, "CORNER"],
		[Messages.HELP_CORNER_BODY, "El número ganador es cualquiera de los cuatro cubiertos."],
		[Messages.HELP_SPLIT_TITLE, "SPLIT"],
		[Messages.HELP_SPLIT_BODY, "El número ganador es cualquiera de los dos cubiertos."],
		[Messages.HELP_STRAIGHT_TITLE, "STRAIGHT UP"],
		[Messages.HELP_STRAIGHT_BODY, "El número ganador es solo el cubierto."],
		[Messages.HELP_BLACK_RED, "Campos 1-18, PAR, ROJO, NEGRO, IMPAR, 19-36 le permite apostar en todos los números respectivos."],
		[Messages.HELP_1TO12, "Los tercios verticales y horizontales cubren los números en sus respectivas filas y columnas."],
		[Messages.HELP_REPEAT_BODY, "Puede repetir las apuestas de su último juego presionando REPETIR cuando su mesa esté vacía."],
		[Messages.HELP_UNDO_BODY, "Al presionar DESHACER, puede retroceder un paso. Por ejemplo, puede deshacer su última apuesta."],
		[Messages.HELP_BET_PRESETS_BODY, "Al presionar APUESTA DEFINIDAS, obtiene una amplia selección de apuestas personalizadas."],
		[Messages.HELP_PROGRESS_BAR_BODY, "Tiempo restante hasta el cierre de apuestas. La barra de tiempo le mostrará la hora de las apuestas de cierre."],
		[Messages.HELP_PROGRESS_BAR_TEXT_BODY, "Mensaje de estado del juego. Cuando juegues, diferentes mensajes te mostrarán el estado del juego."],
		[Messages.HELP_BUTTON_PRESETS_BODY, "Apuestas predefinidas muy populares:\n”JUEGO CERO” - haga apuestas para cubrir números vecinos cero en un rango estrecho, la serie es: 12, 35, 3, 26, 0, 32, 15.\n”SERIE GRANDE” - haga apuestas para cubrir cero números vecinos, la serie es 0, 2, 19, 21, 22, 25, 3, 4, 26, 28, 29, 32, 35, 7, 12, 15, 18.\n”HUÉRFANOS” - esta apuesta presenta números que no pertenecen ni a la ”SERIE 5/8”, ni a la ”GRAND SERIE”, la serie es: 14, 17, 20, 31, 34, 6, 9, 1.\n”SERIE 5/8 ”: esta apuesta presenta los 12 números ubicados en el lado opuesto de la rueda de un solo cero, la serie es: 27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33."],
		[Messages.HELP_HISTORY_BAR, "Historial de números ganados de izquierda a derecha."],
		[Messages.HELP_PLAYER_CREDITS, "Visualización del saldo del jugador con montos de apuestas y últimas ganancias. Al presionarlo, puede alternar entre valores de dinero y crédito."],
		[Messages.HELP_BETTING_CHIPS, "Jugando fichas."],
		[Messages.HELP_ERASER, "Utilice el borrador para eliminar las fichas colocadas. Toque tres veces para eliminar todas las fichas colocadas."],
		[Messages.HELP_PLAYER_NAME_AND_DENOM, "Nombre y denominación del jugador."],
		[Messages.HELP_DENOMINATION, "Denominación."],
		[Messages.HELP_PAYS, "paga"],
		[Messages.HELP_TRACK_FIELD, "Presione cada número en la pista de carreras para apostar a ese número con el valor de ficha seleccionado."],
		[Messages.HELP_TRACK_CHEVAL, "Presione el botón de cheval entre los números para realizar una apuesta dividida en ambos números vecinos."],
		[Messages.HELP_TRACK_CENTER_PRESETS, "Las apuestas predefinidas populares ahora están disponibles en el centro de la pista de carreras."],
		[Messages.HELP_TRACK_WIDE_BETS, "Eligiendo + 0, + 1, + 2, + 4 es posible establecer la cobertura de las apuestas. Donde +0 significa solo la apuesta seleccionada, +1 cubre la apuesta seleccionada y un campo a la izquierda y otro a la derecha, +2 dos campos más a la izquierda a la derecha y +4 cubre cuatro campos de ancho."],
		[Messages.HELP_BETINFO_TITLE, "Apuestas"],
		[Messages.HELP_BETINFO_DESCRIPTION, "A continuación se muestra la tabla de límites actuales por tipo de apuesta. Los valores indicados están en créditos!"],
		[Messages.HELP_BETINFO_MAIN_DESCRIPTION, ""],
		[Messages.HELP_BETINFO_CHIPS_DESCRIPTION, "Valores de fichas para la apuesta seleccionada actualmente"],
		[Messages.HELP_BETINFO_LIMITS_TABLE, "Tabla de límites"],
		[Messages.HELP_BETINFO_MIN_BET, "Apuesta Minima"],
		[Messages.HELP_BETINFO_MAX_BET, "Apuesta Maxima"],
		[Messages.HELP_BETINFO_BET_TYPE, "Tipo de apuesta"],
		[Messages.HELP_BETINFO_BETTYPE_PLAIN, "Straight up"],
		[Messages.HELP_BETINFO_BETTYPE_CAVAL, "Split"],
		[Messages.HELP_BETINFO_BETTYPE_TRASV, "Trio"],
		[Messages.HELP_BETINFO_BETTYPE_CARRE, "Corner"],
		[Messages.HELP_BETINFO_BETTYPE_FIFTH, "Cinco números"],
		[Messages.HELP_BETINFO_BETTYPE_SIXTH, "Seis números"],
		[Messages.HELP_BETINFO_BETTYPE_HLINE, "Linea horizontal"],
		[Messages.HELP_BETINFO_BETTYPE_THIRD, "Tercero"],
		[Messages.HELP_BETINFO_BETTYPE_COLOR, "Rojo / Negro"],
		[Messages.HELP_BETINFO_BETTYPE_ODEVN, "Par / Impar"],
		[Messages.HELP_BETINFO_BETTYPE_PHALF, "Medio"],
		[Messages.HELP_BETINFO_MIN_TABLE_BET, "La apuesta mínima de la mesa es"],
		[Messages.HELP_BETINFO_MAX_TABLE_BET, "La apuesta máxima de la mesa es"],
		[Messages.HELP_BETINFO_NO_MIN_TABLE_BET, "La mesa no tiene apuesta mínima"],
		[Messages.HELP_BETINFO_NO_MAX_TABLE_BET, "La mesa no tiene apuesta máxima"],
		[Messages.HELP_LAYOUT_BUTTON, "Cambie entre la vista del tablero y la pista de carreras presionando el botón de diseño."],
		[Messages.HELP_DISCONNECTION_POLICY, "Si se desconecta de una ronda de juego, las apuestas realizadas seguirán siendo válidas y se liquidarán en su ausencia. Al volver a conectarse, puede ver los resultados de las apuestas con el botón de historial."],
		[Messages.HELP_ERROR_HANDLING, "Si hay un error en el juego, el sistema o el procedimiento del juego, la ronda de juego se detendrá temporalmente. Usted y otros jugadores recibirán una notificación a través del chat del juego o mediante un mensaje emergente en pantalla de que se está investigando el problema. Si el mánager puede resolver el error de inmediato, la ronda de juego continuará con normalidad. Si no es posible una resolución inmediata, la ronda de juego se cancelará y las apuestas iniciales se reembolsarán a todos los jugadores que participaron en la ronda de juego."],
		[Messages.HELP_JACKPOT_LEVEL, "La pantalla de jackpot muestra todos los niveles y valores de bote disponibles. Si un juego es elegible para el premio mayor, la pantalla del premio mayor solo mostrará el nivel activo."],
		[Messages.HELP_JACKPOT_MARKER, "Cuando se revela un número de jackpot seleccionado, se marcará en el tablero."],
		[Messages.GA_HELP_JACKPOT_LEVEL, "La pantalla de jackpot muestra todos los niveles y valores de bote disponibles. Si un juego es elegible para el premio mayor, el nivel específico del premio mayor comenzará a brillar."],
		[Messages.GA_HELP_JACKPOT_MARKER, "Cuando se revela un número de premio mayor seleccionado, se marcará dentro de la pantalla del número de la suerte."],
		[Messages.PAYOUT_BUTTON, "Payout"],
		[Messages.PAYOUT_BUTTON, "Pagar"],
		[Messages.MENU_HISTORY, "Historia"],
		[Messages.MENU_STATISTICS, "Estadísticas"],
		[Messages.MENU_FULLSCREEN, "Pantalla completa"],
		[Messages.MENU_CHAT, "Chat"],
		[Messages.MENU_VOLUME_SETTINGS, "Configuración de volumen"],
		[Messages.MENU_GRAPHICS_SETTINGS, "Configuración de gráficos"],
		[Messages.MENU_WITHDRAW, "Retirar"],
		[Messages.MENU_LOGOUT, "Cerrar sesión"],
		[Messages.SETTINGS_MUSIC_VOLUME, "Volumen de la música"],
		[Messages.SETTINGS_EFFECTS_VOLUME, "Volumen de efectos"],
		[Messages.SETTINGS_VIDEO_VOLUME, "Volumen de vídeo"],
		[Messages.SETTINGS_RENDER, "Calidad de renderizado"],
		[Messages.MIN_TABLE_BET, "Apuesta Minima"],
		[Messages.MAX_TABLE_BET, "Apuesta Maxima"],
		[Messages.TABLE_NO_MAXIMUM, "No límite máximo"],
		[Messages.TABLE_NO_MINIMUM, "No límite mínimo"],
		[Messages.BLACK_SNAKE, "CULEBRA NEGRA"],
		[Messages.NEIGHBORS, "VECINOS"],
		[Messages.SMALL_SERIES, "PEQUEÑA SERIE"],
		[Messages.ALTERNATIVE_ZERO_GAME, "Jugar al cero"],
		[Messages.CLEAR, "BORRAR"],
		[Messages.CLEAR_ALL, "BORRAR TODO?"],
		[Messages.START, "INICIO"],
		[Messages.PLACE_BETS_FOR_SHOWING_POTENTIAL_WINS, "Realice algunas apuestas para mostrar ganancias potenciales"],
		[Messages.SUCCESSFUL_LOGOUT_THANK_YOU, "Cerrar sesión con éxito. Gracias por jugar!"],
		[Messages.SELECT_STAKE_TO_PLAY, "Seleccione la apuesta con la que desea jugar"],
		[Messages.CONTINUE_BUTTON, "Continuar"],
		[Messages.GENERIC_GAME, "JUEGO"],
		[Messages.TRACK_BIG_SERIES, "GRAND SERIE"],
		[Messages.HANDPAY_LOCK_INFO_PLAYER_NAME, "Nombre del jugador"],
		[Messages.HANDPAY_LOCK_INFO_PLAYER_NICKNAME, "Apodo del jugador"],
		[Messages.HANDPAY_LOCK_INFO_STATION_OR_DOMAIN, "En la estación"],
		[Messages.PAYOUT_REQUEST_ARE_YOU_SURE, "Está seguro de que desea\nsolicitar el pago de"],
		[Messages.CLICK_TO_CLOSE_HISTORY_VIEW, "Haga clic en cualquier lugar para cerrar la vista de historial"],
		[Messages.QUESTION_STAKE_DESCRIPTION_SUBTEXT, "límites para apuestas\directas"],
		[Messages.QUESTION_STAKE, "Apuesta"],
		[Messages.INTRO_HOW_TO_PLAY, "Cómo jugar:"],
		[Messages.INTRO_HOW_TO_PLAY_DESCRIPTION, "Seleccione su ficha de apuestas haciendo clic, colóquela haciendo clic nuevamente en los campos deseados."],
		[Messages.BUTTON_HELP, "AYUDA"],
		[Messages.BUTTON_LOCK, "CERRAR"],
		[Messages.BUTTON_DENOMINATION, "DENOM."],
		[Messages.CLOSING, "Closing game.."],
		[Messages.CLICK_LES_FIGURES, "CLICK LES FIGURES"],
		[Messages.CLICK_SIMPLE_SIDEBETS, "CLICK SIDEBETS"],
		[Messages.LESFIGURES_NASSA, "NASSA"],
		[Messages.LESFIGURES_ORPHELINS, "ORPHELINS"],
		[Messages.LESFIGURES_TIER, "TIER"],
		[Messages.LESFIGURES_VOISINS, "VOISINS"],
		[Messages.LESFIGURES_COLLECT, "RETIRAR"],
		[Messages.LESFIGURES_ALLIN, "ACTIVAR TODO EN"],
		[Messages.HELP_BETINFO_BETTYPE_FIGURE, "Figure"],
		[Messages.HELP_BETINFO_BETTYPE_TAUTVA, "Todo en"],
		[Messages.HELP_FIGURES_FIGURE_DESCRIPTION, "Inside each figure there are numbers the sidebet covers.\n\n\"Figure 1\" covers: 1,10,19 and 28.\n\"Figure 2\" covers: 2,11,20 and 29.\n\"Figure 3\" covers: 3,12,21 and 30.\n\"Figure 4\" covers: 4,13,22 and 31.\n\"Figure 5\" covers: 5,14,23 and 32.\n\"Figure 6\" covers: 6,15,24 and 33.\n\"Figure 7\" covers: 7,16,25 and 34.\n\"Figure 8\" covers: 8,17,26 and 35.\n\"Figure 9\" covers: 9,18,27 and 36."],
		[Messages.HELP_FIGURES_FIGURE_WIN, "In case of a winning hand on the figures sidebets, players can choose between collecting the winning bet or activate the game option \"All In\". In the game \"All In\", the chips are moved to the upper box of the last winning figure. Upon inaction collect is automatically selected."],
		[Messages.HELP_FIGURES_TOUTVA_DESCRIPTION, "If the \"All In\" bet is still winning it will pay "],
		[Messages.HELP_FIGURES_TOUTVA_DESCRIPTION_SECONDPART, " - the player will win extra chips compared to regular figures bet that pays "],
	]);
	private static ItalianTranslation: Map<Messages, string> = new Map<Messages, string>([
		[Messages.WAITING, "In attesa..."],
		[Messages.BETS_OPEN_PLACE_BETS, "Le puntate sono aperte, fate il vostro gioco"],
		[Messages.BETS_CLOSING_HURRY, "Le puntate si stanno chiudendo, affrettati!"],
		[Messages.NO_MORE_BETS, "Le puntate sono chiuse"],
		[Messages.WAITING_WIN_NUMBER, "In attesa del numero vincente..."],
		[Messages.DISCONNECTED, "Disconessione, riconessione..."],
		[Messages.BET, "Puntata"],
		[Messages.WIN, "Ultima vincita"],
		// [Messages.BETS_ARE_CLOSED, "Le giocate sono chiuse."],
		[Messages.BETS_ARE_CLOSED, "Attendi la prossima partita."],
		[Messages.NOT_ENOUGH_CREDITS, "Non hai abbastanza credito."],
		[Messages.MAX_NUM_CHIPS_REACHED, "Numero massimo di chips raggiunto!"],
		[Messages.PLAYBOARD_LIMIT_REACHED, "Limite del tavolo raggiunto!"],
		[Messages.MAX_WIN_LIMIT_REACHED, "Limite massimo di vincita raggiunto!"],
		[Messages.MAX_BET_LIMIT_REACHED, "Limite massimo di puntata raggiunto!"],
		[Messages.LEFT_REDS, "ROSSI SINISTRA"],
		[Messages.LEFT_BLACKS, "NERI SINISTRA"],
		[Messages.RIGHT_REDS, "ROSSI DESTRA"],
		[Messages.RIGHT_BLACKS, "NERI DESTRA"],
		[Messages.NEIGBOR_BET, "VICINI"],
		[Messages.TABLE_LAYOUT, "TAVOLO"/*"PROPRIETA TABELLONE"*/],
		[Messages.REPEAT, "RIPETI"],
		[Messages.UNDO, "CANCELLA"],
		[Messages.ZERO_GAME, "GIOCO ZERO"],
		[Messages.BIG_SERIES, "ZERO VICINI"],
		[Messages.ORPHANS, "ORFANELLI"],
		[Messages.SERIE_58, "SERIE 5/8"],
		[Messages.FINALI, "FINALI"],
		[Messages.RED_SPLIT, "SPLIT ROSSI"],
		[Messages.BLACK_SPLIT, "SPLIT NERI"],
		[Messages.HOT_NUMBERS, "NUMERI CALDI"],
		[Messages.RED_SNAKE, "SERPENTE ROSSO"],
		[Messages.PRISON_BETS, "SEI COLONNE"],
		[Messages.MAGIC_RING, "ANELLO MAGICO"],
		[Messages.COLD_NUMBERS, "NUMERI FREDDI"],
		[Messages.TRACK_LAYOUT, "PISTA"/*"IMPOSTAZIONI TRACKING"*/],
		[Messages.PRESETS, "PUNTATE PRESETTATE"],
		[Messages.WRONG_BET, "Puntata sbagliata"],
		[Messages.ERROR_ESTABLISHING_CONNECTION, "Errore di connessione con il server!"],
		[Messages.INCOMPATIBLE_BET, " Puntata imcompatibile, impossibile cambiare in "],
		[Messages.TO_TABLE_LAYOUT, "tavolo."],
		[Messages.TO_TRACK_LAYOUT, "pista."],
		[Messages.CHANGE_TO_BOARD_LAYOUT_TO_BET, "Si prega di cambiare il layout del tavolo per eseguire questa puntata."],
		[Messages.WINNING_NUMBER_IS, "Il numero vincente è "],
		[Messages.TURN_DEVICE_HORIZONTALLY, "Si prega di ruotare il dispositivo in orizzontale!"],
		[Messages.CANNOT_REACH_SERVER_AT, "Impossibile raggiungere il server su "],
		[Messages.BANNED_TRY_AGAIN, "Impossibile connettersi in questo momento. Riprova tra un minuto!"],
		[Messages.BETS_NOT_COMMITED, "Le puntate non sono state messe in tempo!"],
		[Messages.CONNECTING, "In connessione..."],
		[Messages.DOUBLE, "RADDOPPIA"],
		[Messages.CANNOT_SHOW_HISTORY, "Impossibile mostrare la cronologia in un gioco attivo!"],
		[Messages.NO_PLAYED_GAME_HISTORY, "Nessuna partita giocata da mostrare come cronologia!"],
		[Messages.SHOWING_HISTORY, "Visualizzazione della cronologia del gioco:"],
		[Messages.ERROR_MISSING_PARAM, "ERRORE: parametri mancanti!"],
		[Messages.GAME_ID, "ID gioco"],
		[Messages.PLAYER_ID, "ID giocatore"],
		[Messages.CASH, "Contanti"],
		[Messages.CREDIT, "Credito"],
		[Messages.PAINT, "PAINT"],
		[Messages.NORMAL, "NORMAL"],
		[Messages.ONE_CREDIT, "1 CREDITO"],
		[Messages.DEMO, "DEMO"],
		[Messages.MALFUNCTION_VOID_WARNING, "Il malfunzionamento annulla tutte le vincite e le giocate!"],
		[Messages.ERROR_ESTABLISHING_CONNECTION_RETRY, "Errore nello stabilire la connessione! Stiamo riprovando..."],
		[Messages.YOU_HAVE_PLACED_BETS, "Hai le puntate piazzate!"],
		[Messages.ACCOUNT_ALREADY_CONNECTED, "Account gia connesso! Stiamo riprovando..."],
		[Messages.ENTER_PIN, "INSERISCI IL TUO CODICE"],
		[Messages.CLIENT_LOCKED, "CLIENTE BLOCCATO"],
		[Messages.PRESS_LOGOUT_AGAIN_TO_LOGOUT, "Premere ancora una volta \"Logout\" per confermare l'uscita."],
		[Messages.CANNOT_LOGOUT_ACTIVE_GAME, "Impossibile disconnettersi con le puntate piazzate!"],
		[Messages.WRONG_PASSWORD, "Codice errato!"],
		[Messages.HOW_TO_ENTER_FULLSCREEN, "Per entrare a schermo intero:"],
		[Messages.CLICK_TO_CONTINUE, "Clicca ovunque per continuare"],
		[Messages.ENABLE_SOUNDS, "Riproduci suoni?"],
		[Messages.YES, "Si"],
		[Messages.NO, "No"],
		[Messages.GAMES_AGO, "vecchie giocate"],
		[Messages.AUTHENTICATION_PROBLEM, "Problema di autentificazione"],
		[Messages.GO_TO_CASHIER, "Vai dal cashier, per il pagamento..."],
		[Messages.FIELD_LIMIT, "Limite del campo raggiunto!"],
		[Messages.NO_GAME_TO_REPEAT, "Nessuna giocata da ripetere!"],
		[Messages.CLICK_TO_RESTART_GAME, "CLICCA QUI PER RESTARTARE IL GIOCO"],
		[Messages.REPEAT_THIS_GAME, "RIPETI SELEZZIONATO"],
		[Messages.CANNOT_REPEAT_SELECTED_GAME, "Non si puo' ripetere il seguente gioco!"],
		[Messages.I_ACCEPT, "Accetto"],
		[Messages.ACCEPT_TERMS_CONDITIONS, "Giocando a questo gioco accetta i nostri termini e le condizioni di gioco."],
		[Messages.CLICK_TO_CHAT, "CLICCA PER CHATTARE"],
		[Messages.X_PLAYERS_WON, "VINCITA"],
		[Messages.CHANGING_CROUPIER, "Cambio crupier, grazie per aver giocato!"],
		[Messages.SESSION_TIMED_OUT_RESTART_CLIENT, "La tua sessione è terminata per l'inativita. Perfavore ricomincia il gioco per continuare a giocare!"],
		[Messages.CONNECTION_IS_BAD, "LA TUA CONNESSIONE È DEBOLE"],
		[Messages.ANDROID_PRE_FULLSCREEN_MESSAGE, "PREMI OK PER ENTRARE A SCHERMO INTERO"],
		[Messages.DESKTOP_PRE_FULLSCREEN_MESSAGE, "GIOCA A SCHERMO INTERO?"],
		[Messages.SET_PIN, "SETTATE IL VOSTRO CODICE DI SICUREZZA"],
		[Messages.SET_PIN_SUBTEXT, "To servira questo CODICE per fare il Pagamento."],
		[Messages.CONFIRM_PIN, "CONFERMA CODICE"],
		[Messages.CONFIRM_PIN_SUBTEXT, "PERFAVORE RIENSERISCI IL CODICE"],
		[Messages.ENTER_PIN_SUBTEXT, "PERFAVORE INSERITE IL CODICE"],
		[Messages.PAYOUT_REQUESTED, "In attesa del Pagamento"],
		[Messages.SESSION_EXPIRED, "La Vostra sessione è terminata,\n perfavore riprovate!"],
		[Messages.DOUBLE_ZERO_GAME, "GIOCATA DOPPIO ZERO"],
		[Messages.MAX_WIN, "VINCITA MASSIMA"],
		[Messages.LAST_BET, "ULTIMA PUNTATA"],
		[Messages.LAST_WIN, "ULTIMA VINCITA"],
		[Messages.ZERO_GAME_AND_BIG_SERIES, "ZERO VICINI/ GRANDE SERIE"],
		[Messages.NASSA_AND_BIG_SERIES, "NASSA / GRANDE SERIE"],
		[Messages.HISTORY_VIEW_TITLE, "CRONOLOGIA"],
		[Messages.TRACK_VIEW, "VEDI\nPISTA"],
		[Messages.TABLE_VIEW, "VEDI\nTAVOLO"],
		[Messages.SHOW_WINS, "Mostra le vincite"],
		[Messages.HIDE_WINS, "Nascondi le vincite"],
		[Messages.HISTORY_WIN, "Vincita"],
		[Messages.HELP_TITLE, "REGOLAMENTO DEL GIOCO"],
		[Messages.HELP_PLAYER_INTERFACE, "Interfaccia del giocatore"],
		[Messages.HELP_PLAYER_TRACK, "Pista" /*"Traccia del giocatore"*/],
		[Messages.HELP_PLAYER_INFORMATION, "Informazioni Giocatore"],
		[Messages.HELP_TOP_PANEL, "Pannello superiore"],
		[Messages.HELP_JACKPOT, "Montepremi"],
		[Messages.HELP_FIGURES, "Figures"],
		[Messages.HELP_EXTRAS, "Extra"],
		[Messages.HELP_FIVE_NUMBERS_TITLE, "CINQUE NUMERI"],
		[Messages.HELP_FIVE_NUMBERS_BODY, "Il numero vincente è uno dei cinque coperti."],
		[Messages.HELP_FOUR_NUMBERS_TITLE, "QUATTRO NUMERI"],
		[Messages.HELP_FOUR_NUMBERS_BODY, "Il numero vincente è uno dei quattro coperti."],
		[Messages.HELP_TRIO_TITLE, "TERZINA"],
		[Messages.HELP_TRIO_BODY, "Il numero vincente è uno dei tre coperti."],
		[Messages.HELP_SIX_NUMBERS_TITLE, "SESTINA"],
		[Messages.HELP_SIX_NUMBERS_BODY, "Il numero vincente è uno dei sei coperti."],
		[Messages.HELP_CORNER_TITLE, "CARRE"],
		[Messages.HELP_CORNER_BODY, "Il numero vincente è uno dei quattro coperti."],
		[Messages.HELP_SPLIT_TITLE, "CAVALLO"],
		[Messages.HELP_SPLIT_BODY, "Il numero vincente è uno dei due coperti."],
		[Messages.HELP_STRAIGHT_TITLE, "NUMERO PIENO"],
		[Messages.HELP_STRAIGHT_BODY, "Il numero vincente è solo quello coperto."],
		[Messages.HELP_BLACK_RED, "I campi 1-18, PAR, ROSSO, NERO, IMPAR, 19-36 ti permettono di puntare su tutti i respettivi numeri."],
		[Messages.HELP_1TO12, "I terrzi verticali e orizzontali coprono i numeri nelle rispettive righe."],
		[Messages.HELP_REPEAT_BODY, "Puoi ripetere le puntate della tua ultima partita premendo Ripeti, quando il tuo tavolo è vuoto."],
		[Messages.HELP_UNDO_BODY, "Premendo CANCELLA, puoi tornare indietro di un passo. Ad esempio, puoi annullare la tua ultima puntata."],
		[Messages.HELP_BET_PRESETS_BODY, "Premendo PUNTATE PRESETTATE, ottieni un'ampia selezione di puntate personalizzate."],
		[Messages.HELP_PROGRESS_BAR_BODY, "Tempo rimasto fino alla chiusura delle puntate. La barra del tempo ti mostrerà il tempo fino alla chiusura delle puntate."],
		[Messages.HELP_PROGRESS_BAR_TEXT_BODY, "Messaggio di stato del gioco. Quando giochi, diversi messaggi ti mostreranno lo stato del gioco."],
		[Messages.HELP_BUTTON_PRESETS_BODY, "Puntate predefinite molto popolari:\n”GIOCO ZERO” - piazza le tue puntate per coprire lo zero e i numeri vicini in un intervallo ristretto, la serie è: 12, 35, 3, 26, 0, 32, 15.\n”ZERO VICINI” - piazza le puntate per coprire lo zero e i numeri vicini, la serie è 0, 2, 19, 21, 22, 25, 3, 4, 26, 28, 29, 32, 35, 7, 12, 15, 18.\n”ORFANELLI” - questa puntata include numeri, che non appartengono né alla ”SERIE 5/8”, né alla ”ZERO VICINI”, la serie è: 14, 17, 20, 31, 34, 6, 9, 1.\n”SERIE 5/8 ” - questa puntata presenta i 12 numeri situati sul lato opposto dello zero singolo, la serie è: 27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33."],
		[Messages.HELP_HISTORY_BAR, "Cronologia dei numeri di vincita da sinistra a destra."],
		[Messages.HELP_PLAYER_CREDITS, "Visualizzazione del saldo del giocatore con gli importi della puntata e dell'ultima vincita. Premendolo, puoi alternare tra denaro e valore in credito."],
		[Messages.HELP_BETTING_CHIPS, "I chip per giocare."],
		[Messages.HELP_ERASER, "Usa la scopa per rimuovere i chip posizionati. Tocca tre volte per rimuore tutti le chip posizionate."],
		[Messages.HELP_PLAYER_NAME_AND_DENOM, "Nome e denominazione del giocatore."],
		[Messages.HELP_DENOMINATION, "Denominazione."],
		[Messages.HELP_PAYS, "pagamento"],
		[Messages.HELP_TRACK_FIELD, "Premi su qualunque numero sulla pista per puntare sul numero con il valore della fiche selezionato."],
		[Messages.HELP_TRACK_CHEVAL, "Premi il pulsante Cheval tra i numeri, per piazzare una puntata divisa su entrambi i numeri vicini."],
		[Messages.HELP_TRACK_CENTER_PRESETS, "Le puntate popolari predefinite sono ora disponibili al centro della schermata."],
		[Messages.HELP_TRACK_WIDE_BETS, "Scegliendo + 0, + 1, + 2, + 4 è possibile impostare l'ampiezza della copertura delle puntate. Dove +0 significa solo la puntata selezionata, +1 copre la puntata selezionata e un campo a sinistra e uno a destra, +2 altri due campi a sinistra a destra e +4 copre quattro campi di larghezza."],
		[Messages.HELP_BETINFO_TITLE, "Puntate"],
		[Messages.HELP_BETINFO_DESCRIPTION, "Di seguito è riportata la tabella dei limiti attuali per tipo di puntata. I valori elencati sono in crediti!"],
		[Messages.HELP_BETINFO_MAIN_DESCRIPTION, "Le combinazioni su cui è possibile puntare sono svariate:\n Singolo numero con cui si vince 36 volte la somma puntata,\n Cavallo o coppia di numeri con cui si vince 18 volte la somma puntata,\n Terzina con cui si vince 12 volte la somma puntata,\n Carre con cui si vince 9 volte la somma puntata,\n Sestina con cui si vince 6 volte la somma puntata,\n Dozzina, prima, seconda o terza con cui si vince 3 volte la somma puntata\n Colonna, prima, seconda o terza con cui si vince 3 volte la somma puntata.\n\nCi sono poi tre ulteriori tipi di puntata, che in caso di vittoria, restituiscono una volta la somma puntata e sono:\n Numeri pari o dispari,\n I numeri da 1 a 18 o quelli da 19 a 36,\n I numeri rossi o neri."],
		[Messages.HELP_BETINFO_CHIPS_DESCRIPTION, "I chip per l'attuale gamma di puntate"],
		[Messages.HELP_BETINFO_LIMITS_TABLE, "Tabella dei limiti"],
		[Messages.HELP_BETINFO_MIN_BET, "Puntata minima"],
		[Messages.HELP_BETINFO_MAX_BET, "Puntata massima"],
		[Messages.HELP_BETINFO_BET_TYPE, "Tipo di puntata"],
		[Messages.HELP_BETINFO_BETTYPE_PLAIN, "Numero pieno"],
		[Messages.HELP_BETINFO_BETTYPE_CAVAL, "Cavallo"],
		[Messages.HELP_BETINFO_BETTYPE_TRASV, "Terzina"],
		[Messages.HELP_BETINFO_BETTYPE_CARRE, "Carre"],
		[Messages.HELP_BETINFO_BETTYPE_FIFTH, "Quinta"],
		[Messages.HELP_BETINFO_BETTYPE_SIXTH, "Sestina"],
		[Messages.HELP_BETINFO_BETTYPE_HLINE, "Colonna"],
		[Messages.HELP_BETINFO_BETTYPE_THIRD, "Dozzina"],
		[Messages.HELP_BETINFO_BETTYPE_COLOR, "Rossi / Neri"],
		[Messages.HELP_BETINFO_BETTYPE_ODEVN, "Pari / Dispari"],
		[Messages.HELP_BETINFO_BETTYPE_PHALF, "1-18 / 19-36"],
		[Messages.HELP_BETINFO_MIN_TABLE_BET, "La puntata minima al tavolo è"],
		[Messages.HELP_BETINFO_MAX_TABLE_BET, "La puntata massima al tavolo è"],
		[Messages.HELP_BETINFO_NO_MIN_TABLE_BET, "Il tavolo non ha una puntata minima"],
		[Messages.HELP_BETINFO_NO_MAX_TABLE_BET, "Il tavolo non ha una puntata massima"],
		[Messages.HELP_LAYOUT_BUTTON, "Passare dalla visualizzazione del tavolo a quella della pista premendo il pulsante layout." /*"Passa dalla visualizzazione della scheda a quella della pista premendo il pulsante layout."*/],
		[Messages.HELP_DISCONNECTION_POLICY, "Se vieni disconnesso da un round di gioco, tutte le puntate piazzate rimangono valide e vengono saldate in tua assenza. Dopo la riconnessione, puoi visualizzare i risultati dell'ultima puntata con il pulsante della Cronologia."],
		[Messages.HELP_ERROR_HANDLING, " Se si verifica un errore nel gioco, nel sistema o nella procedura di gioco, il gioco verrà temporaneamente sospeso. Tu e gli altri giocatori riceverete una notifica tramite la chat di gioco o tramite un messaggio a comparsa sullo schermo che il problema è in fase di risoluzione. Se il manager riesce a risolvere immediatamente l'errore, il round di gioco continuerà normalmente. Se una risoluzione immediata non è possibile, il round di gioco verrà annullato e le puntate iniziali verranno rimborsate a tutti i giocatori."],
		[Messages.HELP_JACKPOT_LEVEL, "Il display del jackpot mostra tutti i livelli con valori di jackpot disponibili. Se un gioco è idoneo per il jackpot, il display del jackpot mostrerà solo il livello attivo."],
		[Messages.HELP_JACKPOT_MARKER, "Quando viene rivelato il numero jackpot selezionato, esso verrà contrassegnato sul tavolo."],
		[Messages.GA_HELP_JACKPOT_LEVEL, "Il display del jackpot mostra tutti i livelli di jackpot disponibili e i valori del piatto. Se un gioco è idoneo per il jackpot, il livello specifico del jackpot inizierà a brillare."],
		[Messages.GA_HELP_JACKPOT_MARKER, "Quando viene rivelato un numero del jackpot selezionato, verrà contrassegnato all'interno del display del numero fortunato."],
		[Messages.PAYOUT_BUTTON, "Pagamento"],
		[Messages.MENU_HISTORY, "Cronologia"],
		[Messages.MENU_STATISTICS, "Statistica"],
		[Messages.MENU_FULLSCREEN, "Schermo intero"],
		[Messages.MENU_CHAT, "Chat"],
		[Messages.MENU_VOLUME_SETTINGS, "Impostazioni suono"],
		[Messages.MENU_GRAPHICS_SETTINGS, "Impostazioni grafiche"],
		[Messages.MENU_WITHDRAW, "Ritiro"],
		[Messages.MENU_LOGOUT, "Logout"],
		[Messages.SETTINGS_MUSIC_VOLUME, "Volume Musica"],
		[Messages.SETTINGS_EFFECTS_VOLUME, "Volume effetti"],
		[Messages.SETTINGS_VIDEO_VOLUME, "Volume video"],
		[Messages.SETTINGS_RENDER, "Qualità rendering"],
		[Messages.MIN_TABLE_BET, "Puntata minima"],
		[Messages.MAX_TABLE_BET, "Puntata massima"],
		[Messages.TABLE_NO_MAXIMUM, "Nessun limite massimo"],
		[Messages.TABLE_NO_MINIMUM, "Nessun limite minimo"],
		[Messages.BLACK_SNAKE, "SERPENTE NERO"],
		[Messages.NEIGHBORS, "VICINI"],
		[Messages.SMALL_SERIES, "SERIE 5/8"],
		[Messages.ALTERNATIVE_ZERO_GAME, "GIOCO 0"],
		[Messages.CLEAR, "CANCELLA"],
		[Messages.CLEAR_ALL, "CANCELLA TUTTO?"],
		[Messages.START, "START"],
		[Messages.PLACE_BETS_FOR_SHOWING_POTENTIAL_WINS, "Piazza alcune puntate per mostrare le potenziali vincite"],
		[Messages.SUCCESSFUL_LOGOUT_THANK_YOU, "Disconnessione riuscita. Grazie per aver giocato!"],
		[Messages.SELECT_STAKE_TO_PLAY, "Seleziona la gamma per le puntate"],
		[Messages.CONTINUE_BUTTON, "Continua"],
		[Messages.GENERIC_GAME, "GIOCO"],
		[Messages.TRACK_BIG_SERIES, "VICINI DELLO ZERO"],
		[Messages.HANDPAY_LOCK_INFO_PLAYER_NAME, "Nome del giocatore"],
		[Messages.HANDPAY_LOCK_INFO_PLAYER_NICKNAME, "Soprannome del giocatore"],
		[Messages.HANDPAY_LOCK_INFO_STATION_OR_DOMAIN, "Alla stazione"],
		[Messages.PAYOUT_REQUEST_ARE_YOU_SURE, "Vuoi richiedere il\npagamento di"],
		[Messages.CLICK_TO_CLOSE_HISTORY_VIEW, "Clicca ovunque per chiudere la cronologia"],
		[Messages.QUESTION_STAKE_DESCRIPTION_SUBTEXT, "i limiti per la puntata\na un numero singolo"],
		[Messages.QUESTION_STAKE, "Posta in gioco"],
		[Messages.INTRO_HOW_TO_PLAY, "Come si gioca:"],
		[Messages.INTRO_HOW_TO_PLAY_DESCRIPTION, "Seleziona la tua fiche di scommessa facendo clic e posizionala facendo nuovamente clic sul tavolo."],
		[Messages.BUTTON_HELP, "AIUTO"],
		[Messages.BUTTON_LOCK, "SERRATURA"],
		[Messages.BUTTON_DENOMINATION, "DENOM."],
		[Messages.CLOSING, "Chiusura..."],
		[Messages.CLICK_LES_FIGURES, "CLICK LES FIGURES"],
		[Messages.CLICK_SIMPLE_SIDEBETS, "CLICK SIDEBETS"],
		[Messages.LESFIGURES_NASSA, "NASSA"],
		[Messages.LESFIGURES_ORPHELINS, "ORFANELLI"],
		[Messages.LESFIGURES_TIER, "SERIE"],
		[Messages.LESFIGURES_VOISINS, "VICINI"],
		[Messages.LESFIGURES_COLLECT, "RACCOGLI"],
		[Messages.LESFIGURES_ALLIN, "ATTIVA\nALL IN"],
		[Messages.HELP_BETINFO_BETTYPE_FIGURE, "Figure"],
		[Messages.HELP_BETINFO_BETTYPE_TAUTVA, "All In"],
		[Messages.HELP_FIGURES_FIGURE_DESCRIPTION, "All'interno di ogni cifra ci sono i numeri che la scommessa copre.\n\n\"La figura 1\" copre: 1,10,19 e 28.\n\"La figura 2\" copre: 2,11,20 e 29.\n\"La figura 3\" copre: 3,12,21 e 30.\n\"La figura 4\" copre: 4,13,22 e 31.\n\"La figura 5\" copre: 5,14,23 e 32.\n\"La figura 6\" copre: 6,15,24 e 33.\n\"La figura 7\" copre: 7,16,25 e 34.\n\"La figura 8\" copre: 8,17,26 e 35.\n\"La figura 9\" copre: 9,18,27 e 36."],
		[Messages.HELP_FIGURES_FIGURE_WIN, "In caso di mano vincente sulla scommessa, i giocatori possono scegliere tra raccogliere la scommessa vincente o attivare \"All In\". Nel gioco \"All In\", le fiches vengono spostate nella scommessa superiore dell'ultima 'figura' vincente. In caso di inazione, \"raccogli\" viene selezionato automaticamente."],
		[Messages.HELP_FIGURES_TOUTVA_DESCRIPTION, "Se \"All In\" scommessa ha vinto, pagherà "],
		[Messages.HELP_FIGURES_TOUTVA_DESCRIPTION_SECONDPART, " - il giocatore vincerà fiches extra rispetto alla scommessa con cifre regolari che pagano "],
	]);
	private static CroatianTranslation: Map<Messages, string> = new Map<Messages, string>([
		[Messages.WAITING, "Čekanje..."],
		[Messages.BETS_OPEN_PLACE_BETS, "Ulaganje je otvoreno. Postavite svoje uloge."],
		[Messages.BETS_CLOSING_HURRY, "Požurite! Ulozi se zatvaraju!"],
		[Messages.NO_MORE_BETS, "Ulaganje je završeno"],
		[Messages.WAITING_WIN_NUMBER, "Čekamo na dobitni broj..."],
		[Messages.DISCONNECTED, "Isključeno, ponovno povezivanje..."],
		[Messages.BET, "Ulog"],
		[Messages.WIN, "Zadnji dobitak"],
		[Messages.BETS_ARE_CLOSED, "Pričekaj sljedeću igro."],
		[Messages.NOT_ENOUGH_CREDITS, "Nemate dovoljno kredita."],
		[Messages.MAX_NUM_CHIPS_REACHED, "Dosegnut je maksimalni broj žetona!"],
		[Messages.PLAYBOARD_LIMIT_REACHED, "Dosegnuto je ograničenje stanice!"],
		[Messages.MAX_WIN_LIMIT_REACHED, "Dosegnuto je ograničenje maksimalnog dobitka!"],
		[Messages.MAX_BET_LIMIT_REACHED, "Dosegnut je maksimalni limit oklade!"],
		[Messages.LEFT_REDS, "LIJEVI CRVENI"],
		[Messages.LEFT_BLACKS, "LIJEVI CRNI"],
		[Messages.RIGHT_REDS, "DESNI CRVENI"],
		[Messages.RIGHT_BLACKS, "DESNI CRNI"],
		[Messages.NEIGBOR_BET, "SUSJEDSKA KLADA"],
		[Messages.TABLE_LAYOUT, "POGLED TABLA"],
		[Messages.REPEAT, "PONOVI"],
		[Messages.UNDO, "PONIŠTI"],
		[Messages.ZERO_GAME, "NULTA IGRA"],
		[Messages.BIG_SERIES, "VELIKA SERIJA"],
		[Messages.ORPHANS, "ORPHANS"],
		[Messages.SERIE_58, "SERIJA 5/8"],
		[Messages.FINALI, "FINALI"],
		[Messages.RED_SPLIT, "CRVENI RAZVOJ"],
		[Messages.BLACK_SPLIT, "CRNI RAZVOJ"],
		[Messages.HOT_NUMBERS, "VRUĆI BROJEVI"],
		[Messages.RED_SNAKE, "CRVENA ZMIJA"],
		[Messages.PRISON_BETS, "PRISON BETS"],
		[Messages.MAGIC_RING, "MAGIC RING"],
		[Messages.COLD_NUMBERS, "HLADNI BROJEVI"],
		[Messages.TRACK_LAYOUT, "POGLED TRAK"],
		[Messages.PRESETS, "PREPOSTAVKE ULOGA"],
		[Messages.WRONG_BET, "Napačen ulog"],
		[Messages.ERROR_ESTABLISHING_CONNECTION, "Pogreška pri uspostavljanju veze s poslužiteljem!"],
		[Messages.INCOMPATIBLE_BET, "Nekompatibilna ulog, ne može se promijeniti u "],
		[Messages.TO_TABLE_LAYOUT, "pogled table."],
		[Messages.TO_TRACK_LAYOUT, "pogled traka."],
		[Messages.CHANGE_TO_BOARD_LAYOUT_TO_BET, "Molimo promijenite izgled table da izvršite okladu."],
		[Messages.WINNING_NUMBER_IS, "Dobitni broj je "],
		[Messages.TURN_DEVICE_HORIZONTALLY, "Molimo okrenite uređaj vodoravno!"],
		[Messages.CANNOT_REACH_SERVER_AT, "Ne može doći do poslužitelja na "],
		[Messages.BANNED_TRY_AGAIN, "Trenutno se ne mogu povezati. Pokušajte ponovno za minutu!"],
		[Messages.BETS_NOT_COMMITED, "Ulogi nisu izvršene na vrijeme!"],
		[Messages.CONNECTING, "Povezivanje..."],
		[Messages.DOUBLE, "DUPLO"],
		[Messages.CANNOT_SHOW_HISTORY, "Ne može se prikazati povijest u aktivnoj igri!"],
		[Messages.NO_PLAYED_GAME_HISTORY, "Nijedna igrana igra koja se prikazuje kao povijest!"],
		[Messages.SHOWING_HISTORY, "Prikaz povijesti igre:"],
		[Messages.ERROR_MISSING_PARAM, "POGREŠKA: nedostaje parametar(i)!"],
		[Messages.GAME_ID, "ID igre"],
		[Messages.PLAYER_ID, "ID igrača"],
		[Messages.CASH, "Cash"],
		[Messages.CREDIT, "Kredit"],
		[Messages.PAINT, "SLIKATI"],
		[Messages.NORMAL, "NORMALNO"],
		[Messages.ONE_CREDIT, "1 kredit"],
		[Messages.DEMO, "DEMO"],
		[Messages.MALFUNCTION_VOID_WARNING, "Neispravnost poništava sve igre i isplate!"],
		[Messages.ERROR_ESTABLISHING_CONNECTION_RETRY, "Pogreška pri uspostavljanju veze! Ponovni pokušaj..."],
		[Messages.YOU_HAVE_PLACED_BETS, "Uloge so postavljene!"],
		[Messages.ACCOUNT_ALREADY_CONNECTED, "Račun je već povezan! Ponovni pokušaj..."],
		[Messages.ENTER_PIN, "UNESITE SVOJ PIN"],
		[Messages.CLIENT_LOCKED, "KLIJENT ZAKLJUČAN"],
		[Messages.PRESS_LOGOUT_AGAIN_TO_LOGOUT, "Ponovno pritisnite gumb za odjavu za potvrdu odjave"],
		[Messages.CANNOT_LOGOUT_ACTIVE_GAME, "Ne mogu se odjaviti u aktivnoj igri!"],
		[Messages.WRONG_PASSWORD, "Pogrešna lozinka!"],
		[Messages.HOW_TO_ENTER_FULLSCREEN, "Kako ući na cijeli zaslon:"],
		[Messages.CLICK_TO_CONTINUE, "Kliknite bilo gdje za nastavak"],
		[Messages.ENABLE_SOUNDS, "Pustite zvukove?"],
		[Messages.YES, "Da"],
		[Messages.NO, "Ne"],
		[Messages.GAMES_AGO, "igrane igre prije"],
		[Messages.AUTHENTICATION_PROBLEM, "Problem s autentifikacijom"],
		[Messages.GO_TO_CASHIER, "Idite na blagajnu za isplatu..."],
		[Messages.FIELD_LIMIT, "Dosegnuto je ograničenje polja!"],
		[Messages.NO_GAME_TO_REPEAT, "Nema igrane igre za ponavljanje!"],
		[Messages.CLICK_TO_RESTART_GAME, "KLIKNITE OVDJE DA PONOVNO POKRETATE IGRU"],
		[Messages.REPEAT_THIS_GAME, "PONAVLJANJE ODABRANO"],
		[Messages.CANNOT_REPEAT_SELECTED_GAME, "Nije moguće ponoviti odabranu igru!"],
		[Messages.I_ACCEPT, "Prihvaćam"],
		[Messages.ACCEPT_TERMS_CONDITIONS, "Igranjem ove igre prihvaćate naše uvjete i odredbe"],
		[Messages.CLICK_TO_CHAT, "KLIKNITE ZA CHAT"],
		[Messages.X_PLAYERS_WON, "OSVOJIO"],
		[Messages.CHANGING_CROUPIER, "Mijenjam krupije, hvala na igri!"],
		[Messages.SESSION_TIMED_OUT_RESTART_CLIENT, "Vaša sesija je završila zbog neaktivnosti,\n ponovno pokrenite igru da biste nastavili igrati!"],
		[Messages.CONNECTION_IS_BAD, "VAŠA INTERNETSKA VEZA JE LOŠA"],
		[Messages.ANDROID_PRE_FULLSCREEN_MESSAGE, "PRITISNITE OK ZA UTVRĐIVANJE NA CIJELI ZASLON"],
		[Messages.DESKTOP_PRE_FULLSCREEN_MESSAGE, "IGRAJTE U NAČINU CIJELOG ZASLONOG?"],
		[Messages.SET_PIN, "POSTAVITE SVOJ PIN KOD"],
		[Messages.SET_PIN_SUBTEXT, "Prilikom isplate od vas će se tražiti da unesete PIN."],
		[Messages.CONFIRM_PIN, "POTVRDI PIN"],
		[Messages.CONFIRM_PIN_SUBTEXT, "Molimo ponovo unesite svoj PIN."],
		[Messages.ENTER_PIN_SUBTEXT, "Unesite PIN za autentifikaciju."],
		[Messages.PAYOUT_REQUESTED, "ZATRAŽENA ISPLATA"],
		[Messages.SESSION_EXPIRED, "Vaša sesija je istekla,\n ponovo pokrenite igru!"],
		[Messages.DOUBLE_ZERO_GAME, "IGRA DUPLE NULE"],
		[Messages.MAX_WIN, "MAKSIMALNA POBJEDA"],
		[Messages.LAST_BET, "POSLJEDNJI ULOG"],
		[Messages.LAST_WIN, "POSLJEDNJA POBJEDA"],
		[Messages.ZERO_GAME_AND_BIG_SERIES, "IGRA NULA / VELIKA SERIJA"],
		[Messages.NASSA_AND_BIG_SERIES, "NASSA / VELIKA SERIJA"],
		[Messages.HISTORY_VIEW_TITLE, "POGLED POVIJESTI"],
		[Messages.TRACK_VIEW, "POGLED\nTRAK"],
		[Messages.TABLE_VIEW, "POGLED\nTABLA"],
		[Messages.SHOW_WINS, "Prikaži pobjede"],
		[Messages.HIDE_WINS, "Sakrij pobjede"],
		[Messages.HISTORY_WIN, "Pobijedit"],
		[Messages.HELP_TITLE, "POMOĆ"],
		[Messages.HELP_PLAYER_INTERFACE, "Sučelje igrača"],
		[Messages.HELP_PLAYER_TRACK, "Trak igrača"],
		[Messages.HELP_PLAYER_INFORMATION, "Informacije o igraču"],
		[Messages.HELP_TOP_PANEL, "Gornja ploča"],
		[Messages.HELP_JACKPOT, "Jackpot"],
		[Messages.HELP_FIGURES, "Figures"],
		[Messages.HELP_EXTRAS, "Ekstra"],
		[Messages.HELP_FIVE_NUMBERS_TITLE, "PET BROJEVA"],
		[Messages.HELP_FIVE_NUMBERS_BODY, "Pobjednički broj je bilo koji od pet pokrivenih."],
		[Messages.HELP_FOUR_NUMBERS_TITLE, "ČETIRI BROJA"],
		[Messages.HELP_FOUR_NUMBERS_BODY, "Pobjednički broj je bilo koji od četiri pokrivenih."],
		[Messages.HELP_TRIO_TITLE, "TRIO"],
		[Messages.HELP_TRIO_BODY, "Pobjednički broj je bilo koji od tri pokrivenih."],
		[Messages.HELP_SIX_NUMBERS_TITLE, "ŠEST BROJEVA"],
		[Messages.HELP_SIX_NUMBERS_BODY, "Pobjednički broj je bilo koji od šest pokrivenih."],
		[Messages.HELP_CORNER_TITLE, "CORNER"],
		[Messages.HELP_CORNER_BODY, "Pobjednički broj je bilo koji od četiri pokrivenih."],
		[Messages.HELP_SPLIT_TITLE, "SPLIT"],
		[Messages.HELP_SPLIT_BODY, "Pobjednički broj je bilo koji od dva pokrivena."],
		[Messages.HELP_STRAIGHT_TITLE, "STRAIGHT UP"],
		[Messages.HELP_STRAIGHT_BODY, "Pobjednički broj je samo onaj koji je pokriven."],
		[Messages.HELP_BLACK_RED, "Polja 1-18, PAR, CRVENA, CRNA, IMPAR, 19-36 omogućuju vam da se kladite na sve odgovarajuće brojeve."],
		[Messages.HELP_1TO12, "Vertikalne i horizontalne trećine pokrivaju brojeve u svojim recima i stupcima."],
		[Messages.HELP_REPEAT_BODY, "Možete ponoviti oklade iz svoje posljednje utakmice pritiskom na PONOVI kada je vaša tabla prazana."],
		[Messages.HELP_UNDO_BODY, "Pritiskom na PONIŠTI možete se vratiti za jedan korak. Na primjer, možete poništiti svoju posljednju okladu."],
		[Messages.HELP_BET_PRESETS_BODY, "Pritiskom na PREPOSTAVKE ULOGA dobivate širok izbor prilagođenih uloga."],
		[Messages.HELP_PROGRESS_BAR_BODY, "Ostalo je vrijeme do zatvaranja uloga. Vremenska traka će vam pokazati vrijeme zatvaranja uloga."],
		[Messages.HELP_PROGRESS_BAR_TEXT_BODY, "Poruka o statusu igre. Kada igrate, različite poruke će vam pokazati status igre."],
		[Messages.HELP_BUTTON_PRESETS_BODY, "Vrlo popularne unaprijed definirane oklade:\n”ZERO GAME” - stavite oklade za pokrivanje nula susjednih brojeva u uskom rasponu, serija je: 12, 35, 3, 26, 0, 32, 15.\n”VELIKA SERIJA” - mjesto oklade za pokrivanje nula susjednih brojeva, serija je 0, 2, 19, 21, 22, 25, 3, 4, 26, 28, 29, 32, 35, 7, 12, 15, 18.\n”ORPHANS” - ova oklada sadrži brojeve koji ne pripadaju ni ”SERIJA 5/8”, niti ”VELIKA SERIJI”, serija je: 14, 17, 20, 31, 34, 6, 9, 1.\n”SERIJA 5/8 ” - ova oklada sadrži 12 brojeva koji se nalaze na suprotnoj strani kotača s jednom nulom, serija je: 27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33. "],
		[Messages.HELP_HISTORY_BAR, "Osvojite povijest brojeva s lijeva na desno."],
		[Messages.HELP_PLAYER_CREDITS, "Prikaz stanja igrača s iznosima oklade i posljednjeg dobitka. Pritiskom na njega možete se prebacivati između vrijednosti novca i kredita."],
		[Messages.HELP_BETTING_CHIPS, "Žetoni za igranje."],
		[Messages.HELP_ERASER, "Upotrijebite gumicu za uklanjanje postavljenih čipova. Dodirnite tri puta da uklonite sve postavljene žetone."],
		[Messages.HELP_PLAYER_NAME_AND_DENOM, "Ime igrača i denominacija."],
		[Messages.HELP_DENOMINATION, "Denominacija."],
		[Messages.HELP_PAYS, "plaća"],
		[Messages.HELP_TRACK_FIELD, "Pritisnite svaki broj na traku kako biste se kladili na taj broj s odabranom vrijednošću žetona."],
		[Messages.HELP_TRACK_CHEVAL, "Pritisnite tipku cheval između brojeva, da položite podijeljenu okladu na oba susjedna broja."],
		[Messages.HELP_TRACK_CENTER_PRESETS, "Popularne unaprijed definirane oklade sada su dostupne u središtu traka."],
		[Messages.HELP_TRACK_WIDE_BETS, "Odabirom + 0, + 1, + 2, + 4 moguće je podesiti pokrivenost oklada. Gdje +0 znači samo odabranu okladu, +1 pokriva odabranu okladu i jedno polje lijevo i jedno desno, +2 još dva polja s lijeve strane udesno, a +4 pokriva četiri polja u širinu."],
		[Messages.HELP_BETINFO_TITLE, "Ulog"],
		[Messages.HELP_BETINFO_DESCRIPTION, "Ispod je tablica trenutnih ograničenja po vrsti oklade. Navedene vrijednosti su u bodovima!"],
		[Messages.HELP_BETINFO_MAIN_DESCRIPTION, ""],
		[Messages.HELP_BETINFO_CHIPS_DESCRIPTION, "Vrijednosti žetona za trenutno odabrani ulog"],
		[Messages.HELP_BETINFO_LIMITS_TABLE, "Tablica granica"],
		[Messages.HELP_BETINFO_MIN_BET, "Min. ulog "],
		[Messages.HELP_BETINFO_MAX_BET, "Max. ulog"],
		[Messages.HELP_BETINFO_BET_TYPE, "Vrsta uloga"],
		[Messages.HELP_BETINFO_BETTYPE_PLAIN, "Straight up"],
		[Messages.HELP_BETINFO_BETTYPE_CAVAL, "Split"],
		[Messages.HELP_BETINFO_BETTYPE_TRASV, "Trio"],
		[Messages.HELP_BETINFO_BETTYPE_CARRE, "Corner"],
		[Messages.HELP_BETINFO_BETTYPE_FIFTH, "Pet brojeva"],
		[Messages.HELP_BETINFO_BETTYPE_SIXTH, "Šest brojeva"],
		[Messages.HELP_BETINFO_BETTYPE_HLINE, "Vodoravna crta"],
		[Messages.HELP_BETINFO_BETTYPE_THIRD, "Third"],
		[Messages.HELP_BETINFO_BETTYPE_COLOR, "Crvena / Crna"],
		[Messages.HELP_BETINFO_BETTYPE_ODEVN, "Nepar / Par"],
		[Messages.HELP_BETINFO_BETTYPE_PHALF, "Pola"],
		[Messages.HELP_BETINFO_MIN_TABLE_BET, "Min. ulog table je"],
		[Messages.HELP_BETINFO_MAX_TABLE_BET, "Max. ulog table je"],
		[Messages.HELP_BETINFO_NO_MIN_TABLE_BET, "Tabla nema minimalni ulog"],
		[Messages.HELP_BETINFO_NO_MAX_TABLE_BET, "Tabla nema miksmimalni ulog"],
		[Messages.HELP_LAYOUT_BUTTON, "Prebacivanje između prikaza ploče i trkaće staze pritiskom na tipku za raspored."],
		[Messages.HELP_DISCONNECTION_POLICY, "Ako ste isključeni iz runde igre, sve postavljene oklade ostaju važeće i podmiruju se u vašoj odsutnosti. Nakon ponovnog povezivanja, možete vidjeti rezultate oklada pomoću gumba za povijest."],
		[Messages.HELP_ERROR_HANDLING, "Ako postoji greška u igri, sustavu ili postupku igre, runda igre će biti privremeno pauzirana. Vi i drugi igrači bit ćete obaviješteni putem chata u igri ili skočnom porukom na zaslonu da se problem istražuje. Ako voditelj može odmah otkloniti pogrešku, runda igre će se nastaviti normalno. Ako trenutačno rješenje nije moguće, runda igre će se otkazati, a početne oklade će biti vraćene svim igračima koji su sudjelovali u rundi igre."],
		[Messages.HELP_JACKPOT_LEVEL, "Zaslon Jackpota prikazuje sve dostupne razine jackpota i vrijednosti pota. Ako igra ispunjava uvjete za jackpot, prikaz jackpota prikazuje samo aktivnu razinu."],
		[Messages.HELP_JACKPOT_MARKER, "Kada se otkrije odabrani broj jackpota, bit će označen na tabli."],
		[Messages.GA_HELP_JACKPOT_LEVEL, "Zaslon Jackpota prikazuje sve dostupne razine jackpota i vrijednosti pota. Ako igra ispunjava uvjete za jackpot, određena razina jackpota počet će svijetliti."],
		[Messages.GA_HELP_JACKPOT_MARKER, "Kada se otkrije odabrani jackpot broj, bit će označen unutar zaslona sretnog broja."],
		[Messages.PAYOUT_BUTTON, "Isplata"],
		[Messages.MENU_HISTORY, "Povijest"],
		[Messages.MENU_STATISTICS, "Statistika"],
		[Messages.MENU_FULLSCREEN, "Puni zaslon"],
		[Messages.MENU_CHAT, "Chat"],
		[Messages.MENU_VOLUME_SETTINGS, "Postavke glasnoće"],
		[Messages.MENU_GRAPHICS_SETTINGS, "Postavke grafike"],
		[Messages.MENU_WITHDRAW, "Povući"],
		[Messages.MENU_LOGOUT, "Odjavite se"],
		[Messages.SETTINGS_MUSIC_VOLUME, "Glasnoća glazbe"],
		[Messages.SETTINGS_EFFECTS_VOLUME, "Glasnoća učinca"],
		[Messages.SETTINGS_VIDEO_VOLUME, "Glasnoća videa"],
		[Messages.SETTINGS_RENDER, "Kvaliteta renderiranja"],
		[Messages.MIN_TABLE_BET, "Min. ulog"],
		[Messages.MAX_TABLE_BET, "Max. ulog"],
		[Messages.TABLE_NO_MAXIMUM, "Nema maksimalnog ograničenja"],
		[Messages.TABLE_NO_MINIMUM, "Nema minimalnog ograničenja"],
		[Messages.BLACK_SNAKE, "CRNA ZMIJA"],
		[Messages.NEIGHBORS, "SUSJEDI"],
		[Messages.SMALL_SERIES, "MALA SERIJA"],
		[Messages.ALTERNATIVE_ZERO_GAME, "0 GAME"],
		[Messages.CLEAR, "OBRIŠI"],
		[Messages.CLEAR_ALL, "OBRIŠI SVE?"],
		[Messages.START, "POČETAK"],
		[Messages.PLACE_BETS_FOR_SHOWING_POTENTIAL_WINS, "Stavite neke oklade da pokažete potencijalne pobjede"],
		[Messages.SUCCESSFUL_LOGOUT_THANK_YOU, "Uspješno odjavljen. Hvala ti na igranju!"],
		[Messages.SELECT_STAKE_TO_PLAY, "Odaberite ulog s kojim želite igrati"],
		[Messages.CONTINUE_BUTTON, "Nastaviti"],
		[Messages.GENERIC_GAME, "IGRA"],
		[Messages.TRACK_BIG_SERIES, "VELIKA SERIJA"],
		[Messages.HANDPAY_LOCK_INFO_PLAYER_NAME, "Igračevo ime"],
		[Messages.HANDPAY_LOCK_INFO_PLAYER_NICKNAME, "Nadimak igrača"],
		[Messages.HANDPAY_LOCK_INFO_STATION_OR_DOMAIN, "Na stanici"],
		[Messages.PAYOUT_REQUEST_ARE_YOU_SURE, "Jeste li sigurni da želite\nzatražiti isplatu od"],
		[Messages.CLICK_TO_CLOSE_HISTORY_VIEW, "Kliknite bilo gdje da zatvorite prikaz povijesti"],
		[Messages.QUESTION_STAKE_DESCRIPTION_SUBTEXT, "ograničenje za straight\nup uloge"],
		[Messages.QUESTION_STAKE, "Ulog"],
		[Messages.INTRO_HOW_TO_PLAY, "Kako igrati:"],
		[Messages.INTRO_HOW_TO_PLAY_DESCRIPTION, "Odaberite svoj žeton za klađenje klikom, postavite ga ponovnim klikom na željena polja."],
		[Messages.BUTTON_HELP, "POMOĆ"],
		[Messages.BUTTON_LOCK, "ZAKLJUČAJ"],
		[Messages.BUTTON_DENOMINATION, "DENOM."],
		[Messages.CLOSING, "Zatvaranje..."],
		[Messages.CLICK_LES_FIGURES, "CLICK LES FIGURES"],
		[Messages.CLICK_SIMPLE_SIDEBETS, "CLICK SIDEBETS"],
		[Messages.LESFIGURES_NASSA, "NASSA"],
		[Messages.LESFIGURES_ORPHELINS, "ORPHELINS"],
		[Messages.LESFIGURES_TIER, "TIER"],
		[Messages.LESFIGURES_VOISINS, "VOISINS"],
		[Messages.LESFIGURES_COLLECT, "POVUĆI"],
		[Messages.LESFIGURES_ALLIN, "AKTIVIRAJ\nALL IN"],
		[Messages.HELP_BETINFO_BETTYPE_FIGURE, "Figure"],
		[Messages.HELP_BETINFO_BETTYPE_TAUTVA, "All In"],
		[Messages.HELP_FIGURES_FIGURE_DESCRIPTION, "Inside each figure there are numbers the sidebet covers.\n\n\"Figure 1\" covers: 1,10,19 and 28.\n\"Figure 2\" covers: 2,11,20 and 29.\n\"Figure 3\" covers: 3,12,21 and 30.\n\"Figure 4\" covers: 4,13,22 and 31.\n\"Figure 5\" covers: 5,14,23 and 32.\n\"Figure 6\" covers: 6,15,24 and 33.\n\"Figure 7\" covers: 7,16,25 and 34.\n\"Figure 8\" covers: 8,17,26 and 35.\n\"Figure 9\" covers: 9,18,27 and 36."],
		[Messages.HELP_FIGURES_FIGURE_WIN, "In case of a winning hand on the figures sidebets, players can choose between collecting the winning bet or activate the game option \"All In\". In the game \"All In\", the chips are moved to the upper box of the last winning figure. Upon inaction collect is automatically selected."],
		[Messages.HELP_FIGURES_TOUTVA_DESCRIPTION, "If the \"All In\" bet is still winning it will pay "],
		[Messages.HELP_FIGURES_TOUTVA_DESCRIPTION_SECONDPART, " - the player will win extra chips compared to regular figures bet that pays "],
	]);
	private static DeutschTranslation: Map<Messages, string> = new Map<Messages, string>([
		[Messages.WAITING, "Warten..."],
		[Messages.BETS_OPEN_PLACE_BETS, "Wetten sind offen, platzieren Sie Ihre Wetten"],
		[Messages.BETS_CLOSING_HURRY, "Die Wetten schließen, beeil dich!"],
		[Messages.NO_MORE_BETS, "Keine Wetten mehr"],
		[Messages.WAITING_WIN_NUMBER, "Warten auf Gewinnnummer..."],
		[Messages.DISCONNECTED, "Getrennt, Verbindung neu..."],
		[Messages.BET, "Wette"],
		[Messages.WIN, "Letzter Gewinn"],
		[Messages.BETS_ARE_CLOSED, "Auf nächstes Spiel warten."],
		[Messages.NOT_ENOUGH_CREDITS, "Du hast nicht genug Credits."],
		[Messages.MAX_NUM_CHIPS_REACHED, "Maximale Anzahl an Chips erreicht!"],
		[Messages.PLAYBOARD_LIMIT_REACHED, "Playboard-Limit erreicht!"],
		[Messages.MAX_WIN_LIMIT_REACHED, "Maximale Gewinngrenze erreicht!"],
		[Messages.MAX_BET_LIMIT_REACHED, "Maximales Einsatzlimit erreicht!"],
		[Messages.LEFT_REDS, "LINKE ROTE"],
		[Messages.LEFT_BLACKS, "LINKE SCHWARZE"],
		[Messages.RIGHT_REDS, "RECHTE RODS"],
		[Messages.RIGHT_BLACKS, "RECHTE SCHWARZE"],
		[Messages.NEIGBOR_BET, "NEIGHBOR WETTE"],
		[Messages.TABLE_LAYOUT, "TISCH-LAYOUT"],
		[Messages.REPEAT, "WIEDERHOLEN"],
		[Messages.UNDO, "RÜCKGÄNGIG MACHEN"],
		[Messages.ZERO_GAME, "NULL SPIEL"],
		[Messages.BIG_SERIES, "GROSSE SERIE"],
		[Messages.ORPHANS, "WAISEN"],
		[Messages.SERIE_58, "SERIE 5/8"],
		[Messages.FINALI, "FINALI"],
		[Messages.RED_SPLIT, "RED SPLIT"],
		[Messages.BLACK_SPLIT, "BLACK SPLIT"],
		[Messages.HOT_NUMBERS, "HEISSE ZAHLEN"],
		[Messages.RED_SNAKE, "ROTE SCHLANGE"],
		[Messages.PRISON_BETS, "GEFÄNGNISWETTEN"],
		[Messages.MAGIC_RING, "MAGIC RING"],
		[Messages.COLD_NUMBERS, "KALTE ZAHLEN"],
		[Messages.TRACK_LAYOUT, "STRECKEN-LAYOUT"],
		[Messages.PRESETS, "WETTEINSTELLUNGEN"],
		[Messages.WRONG_BET, "Falsche Wette"],
		[Messages.ERROR_ESTABLISHING_CONNECTION, "Fehler beim Herstellen der Verbindung zum Server!"],
		[Messages.INCOMPATIBLE_BET, "Inkompatible Wette, kann nicht geändert werden in "],
		[Messages.TO_TABLE_LAYOUT, "Tabellenlayout."],
		[Messages.TO_TRACK_LAYOUT, "Streckenlayout."],
		[Messages.CHANGE_TO_BOARD_LAYOUT_TO_BET, "Wechseln Sie bitte zum Board-Layout, um Wetten durchzuführen."],
		[Messages.WINNING_NUMBER_IS, "Die Gewinnzahl ist "],
		[Messages.TURN_DEVICE_HORIZONTALLY, "Bitte drehen Sie das Gerät horizontal!"],
		[Messages.CANNOT_REACH_SERVER_AT, "Kann Server nicht erreichen unter "],
		[Messages.BANNED_TRY_AGAIN, "Im Moment kann keine Verbindung hergestellt werden. Versuchen Sie es in einer Minute erneut!"],
		[Messages.BETS_NOT_COMMITED, "Wetten wurden nicht rechtzeitig abgeschlossen!"],
		[Messages.CONNECTING, "Verbinden..."],
		[Messages.DOUBLE, "DOPPELT"],
		[Messages.CANNOT_SHOW_HISTORY, "Verlauf kann in einem aktiven Spiel nicht angezeigt werden!"],
		[Messages.NO_PLAYED_GAME_HISTORY, "Kein gespieltes Spiel als Verlauf anzuzeigen!"],
		[Messages.SHOWING_HISTORY, "Spielverlauf anzeigen:"],
		[Messages.ERROR_MISSING_PARAM, "FEHLER: Fehlende(r) Parameter!"],
		[Messages.GAME_ID, "Spiel-ID"],
		[Messages.PLAYER_ID, "Spieler-ID"],
		[Messages.CASH, "Kasse"],
		[Messages.CREDIT, "Kredit"],
		[Messages.PAINT, "MALEN"],
		[Messages.NORMAL, "NORMAL"],
		[Messages.ONE_CREDIT, "1 Kredit"],
		[Messages.DEMO, "DEMO"],
		[Messages.MALFUNCTION_VOID_WARNING, "Fehlfunktion macht alle Spiele und Auszahlungen ungültig!"],
		[Messages.ERROR_ESTABLISHING_CONNECTION_RETRY, "Fehler beim Verbindungsaufbau! Neuer Versuch..."],
		[Messages.YOU_HAVE_PLACED_BETS, "Sie haben Wetten platziert!"],
		[Messages.ACCOUNT_ALREADY_CONNECTED, "Konto bereits verbunden! Neuer Versuch..."],
		[Messages.ENTER_PIN, "GEBEN SIE IHRE PIN EIN"],
		[Messages.CLIENT_LOCKED, "CLIENT GESPERRT"],
		[Messages.PRESS_LOGOUT_AGAIN_TO_LOGOUT, "Drücken Sie die Abmeldetaste erneut, um die Abmeldung zu bestätigen"],
		[Messages.CANNOT_LOGOUT_ACTIVE_GAME, "Abmelden in einem aktiven Spiel nicht möglich!"],
		[Messages.WRONG_PASSWORD, "Falsches Passwort!"],
		[Messages.HOW_TO_ENTER_FULLSCREEN, "Vollbild aufrufen:"],
		[Messages.CLICK_TO_CONTINUE, "Klicken Sie irgendwo, um fortzufahren"],
		[Messages.ENABLE_SOUNDS, "Sounds abspielen?"],
		[Messages.YES, "Ja"],
		[Messages.NO, "Nein"],
		[Messages.GAMES_AGO, "vorher gespielte Spiele"],
		[Messages.AUTHENTICATION_PROBLEM, "Authentifizierungsproblem"],
		[Messages.GO_TO_CASHIER, "Zur Auszahlung zur Kasse gehen..."],
		[Messages.FIELD_LIMIT, "Feldlimit erreicht!"],
		[Messages.NO_GAME_TO_REPEAT, "Kein gespieltes Spiel zum Wiederholen!"],
		[Messages.CLICK_TO_RESTART_GAME, "KLICKEN SIE HIER, UM DAS SPIEL NEU ZU STARTEN"],
		[Messages.REPEAT_THIS_GAME, "WIEDERHOLEN AUSGEWÄHLT"],
		[Messages.CANNOT_REPEAT_SELECTED_GAME, "Ausgewähltes Spiel kann nicht wiederholt werden!"],
		[Messages.I_ACCEPT, "Ich akzeptiere"],
		[Messages.ACCEPT_TERMS_CONDITIONS, "Durch das Spielen dieses Spiels akzeptierst du unsere Allgemeinen Geschäftsbedingungen"],
		[Messages.CLICK_TO_CHAT, "KLICKEN SIE ZUM CHAT"],
		[Messages.X_PLAYERS_WON, "GEWONNEN"],
		[Messages.CHANGING_CROUPIER, "Croupier wechseln, danke fürs Spielen!"],
		[Messages.SESSION_TIMED_OUT_RESTART_CLIENT, "Ihre Sitzung wurde aufgrund von Inaktivität beendet,\n bitte starten Sie das Spiel neu, um weiterzuspielen!"],
		[Messages.CONNECTION_IS_BAD, "IHRE INTERNETVERBINDUNG IST SCHLECHT"],
		[Messages.ANDROID_PRE_FULLSCREEN_MESSAGE, "DRÜCKE OK, UM VOLLBILD ZU GEHEN"],
		[Messages.DESKTOP_PRE_FULLSCREEN_MESSAGE, "IM VOLLBILDMODUS SPIELEN?"],
		[Messages.SET_PIN, "LEGEN SIE IHREN PIN-CODE EIN"],
		[Messages.SET_PIN_SUBTEXT, "Sie werden aufgefordert, bei der Auszahlung eine PIN einzugeben."],
		[Messages.CONFIRM_PIN, "PIN BESTÄTIGEN"],
		[Messages.CONFIRM_PIN_SUBTEXT, "Bitte geben Sie Ihre PIN erneut ein."],
		[Messages.ENTER_PIN_SUBTEXT, "Bitte geben Sie Ihre Authentifizierungs-PIN ein."],
		[Messages.PAYOUT_REQUESTED, "AUSZAHLUNG ANGEFORDERT"],
		[Messages.SESSION_EXPIRED, "Ihre Sitzung ist abgelaufen,\n bitte starten Sie das Spiel neu!"],
		[Messages.DOUBLE_ZERO_GAME, "DOUBLE-ZERO-SPIEL"],
		[Messages.MAX_WIN, "MAX GEWINN"],
		[Messages.LAST_BET, "LETZTE WETTE"],
		[Messages.LAST_WIN, "LETZTER GEWINN"],
		[Messages.ZERO_GAME_AND_BIG_SERIES, "NULL SPIEL / GROSSE SERIE"],
		[Messages.NASSA_AND_BIG_SERIES, "NASSA / GROSSE SERIE"],
		[Messages.HISTORY_VIEW_TITLE, "VERLAUFSANSICHT"],
		[Messages.TRACK_VIEW, "STRECKEN\nLAYOUT"],
		[Messages.TABLE_VIEW, "TISCH\nLAYOUT"],
		[Messages.SHOW_WINS, "Siege anzeigen"],
		[Messages.HIDE_WINS, "Gewinne ausblenden"],
		[Messages.HISTORY_WIN, "Gewinn"],
		[Messages.HELP_TITLE, "HILFE"],
		[Messages.HELP_PLAYER_INTERFACE, "Player-Oberfläche"],
		[Messages.HELP_PLAYER_TRACK, "Spieler-Track"],
		[Messages.HELP_PLAYER_INFORMATION, "Spielerinformationen"],
		[Messages.HELP_TOP_PANEL, "Oberes Bedienfeld"],
		[Messages.HELP_JACKPOT, "Jackpot"],
		[Messages.HELP_FIGURES, "Figures"],
		[Messages.HELP_EXTRAS, "Extras"],
		[Messages.HELP_FIVE_NUMBERS_TITLE, "FÜNF NUMMERN"],
		[Messages.HELP_FIVE_NUMBERS_BODY, "Die Gewinnzahl ist eine der fünf verdeckten."],
		[Messages.HELP_FOUR_NUMBERS_TITLE, "VIER NUMMERN"],
		[Messages.HELP_FOUR_NUMBERS_BODY, "Die Gewinnzahl ist eine der vier verdeckten."],
		[Messages.HELP_TRIO_TITLE, "TRIO"],
		[Messages.HELP_TRIO_BODY, "Die Gewinnzahl ist eine der drei verdeckten."],
		[Messages.HELP_SIX_NUMBERS_TITLE, "SECHS NUMMERN"],
		[Messages.HELP_SIX_NUMBERS_BODY, "Die Gewinnzahl ist eine der sechs verdeckten."],
		[Messages.HELP_CORNER_TITLE, "CORNER"],
		[Messages.HELP_CORNER_BODY, "Die Gewinnzahl ist eine der vier verdeckten."],
		[Messages.HELP_SPLIT_TITLE, "SPLIT"],
		[Messages.HELP_SPLIT_BODY, "Die Gewinnzahl ist eine der beiden verdeckten."],
		[Messages.HELP_STRAIGHT_TITLE, "STRAIGHT UP"],
		[Messages.HELP_STRAIGHT_BODY, "Die Gewinnzahl ist nur die verdeckte."],
		[Messages.HELP_BLACK_RED, "Felder 1-18, PAR, ROT, SCHWARZ, IMPAR, 19-36 ermöglichen es Ihnen, auf alle entsprechenden Zahlen zu setzen."],
		[Messages.HELP_1TO12, "Vertikale und horizontale Drittel decken Zahlen in ihren jeweiligen Zeilen und Spalten ab."],
		[Messages.HELP_REPEAT_BODY, "Sie können Wetten aus Ihrem letzten Spiel wiederholen, indem Sie REPEAT drücken, wenn Ihr Tisch leer ist."],
		[Messages.HELP_UNDO_BODY, "Durch Drücken von UNDO können Sie einen Schritt zurückgehen. Beispielsweise können Sie Ihre letzte Wette rückgängig machen."],
		[Messages.HELP_BET_PRESETS_BODY, "Durch Drücken von BET PRESETS erhalten Sie eine große Auswahl an benutzerdefinierten Wetten."],
		[Messages.HELP_PROGRESS_BAR_BODY, "Verbleibende Zeit bis zum Schließen von Wetten. Die Zeitleiste zeigt Ihnen die Zeit des Schließens von Wetten."],
		[Messages.HELP_PROGRESS_BAR_TEXT_BODY, "Spielstatusnachricht. Wenn Sie spielen, zeigen Ihnen verschiedene Nachrichten den Status des Spiels."],
		[Messages.HELP_BUTTON_PRESETS_BODY, "Sehr beliebte vordefinierte Wetten:\n”ZERO GAME” - platzieren Sie Wetten, um null benachbarte Zahlen in einem engen Bereich abzudecken, die Reihe ist: 12, 35, 3, 26, 0, 32, 15.\n ”GROSSE REIHE” – Platzieren Sie Wetten, um null benachbarte Zahlen abzudecken, die Reihe ist 0, 2, 19, 21, 22, 25, 3, 4, 26, 28, 29, 32, 35, 7, 12, 15, 18. \n”WAISEN” - diese Wette enthält Zahlen, die weder zu ”SERIE 5/8” noch zu ”GROSE SERIE” gehören, die Serie ist: 14, 17, 20, 31, 34, 6, 9, 1.\ n „SERIE 5/8“ – diese Wette beinhaltet die 12 Zahlen, die sich auf der gegenüberliegenden Seite des Rades mit einer einzigen Null befinden, die Reihe ist: 27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33."],
		[Messages.HELP_HISTORY_BAR, "Gewinnverlauf von links nach rechts."],
		[Messages.HELP_PLAYER_CREDITS, "Anzeige des Spielerguthabens mit Einsätzen und letzten Gewinnbeträgen. Durch Drücken können Sie zwischen Geld- und Guthabenwerten umschalten."],
		[Messages.HELP_BETTING_CHIPS, "Chips spielen."],
		[Messages.HELP_ERASER, "Verwenden Sie den Radiergummi, um platzierte Chips zu entfernen. Tippen Sie dreimal, um alle platzierten Chips zu entfernen."],
		[Messages.HELP_PLAYER_NAME_AND_DENOM, "Spielername und Bezeichnung."],
		[Messages.HELP_DENOMINATION, "Bezeichnung."],
		[Messages.HELP_PAYS, "bezahlt"],
		[Messages.HELP_TRACK_FIELD, "Drücken Sie jede Zahl auf der Rennstrecke, um auf diese Zahl mit dem ausgewählten Chipwert zu setzen."],
		[Messages.HELP_TRACK_CHEVAL, "Drücken Sie zwischen den Zahlen auf die Cheval-Taste, um eine geteilte Wette auf beide benachbarten Zahlen zu platzieren."],
		[Messages.HELP_TRACK_CENTER_PRESETS, "Beliebte vordefinierte Wetten sind jetzt in der Mitte der Rennstrecke verfügbar."],
		[Messages.HELP_TRACK_WIDE_BETS, "Durch die Auswahl von + 0, + 1, + 2, + 4 ist es möglich, die Abdeckung der Wetten festzulegen. Wobei +0 nur die ausgewählte Wette bedeutet, +1 die ausgewählte Wette und ein Feld dazu abdeckt links und eins rechts, +2 zwei weitere Felder links nach rechts und +4 deckt vier Felder in der Breite ab."],
		[Messages.HELP_BETINFO_TITLE, "Wetten"],
		[Messages.HELP_BETINFO_DESCRIPTION, "Unten ist die Tabelle der aktuellen Limits pro Wettart. Die aufgelisteten Werte sind in Credits!"],
		[Messages.HELP_BETINFO_MAIN_DESCRIPTION, ""],
		[Messages.HELP_BETINFO_CHIPS_DESCRIPTION, "Chip Werte für den aktuell ausgewählten Einsatz"],
		[Messages.HELP_BETINFO_LIMITS_TABLE, "Grenzwerttabelle"],
		[Messages.HELP_BETINFO_MIN_BET, "Mindestwette"],
		[Messages.HELP_BETINFO_MAX_BET, "Maximale Wette"],
		[Messages.HELP_BETINFO_BET_TYPE, "Wettart"],
		[Messages.HELP_BETINFO_BETTYPE_PLAIN, "Straight up"],
		[Messages.HELP_BETINFO_BETTYPE_CAVAL, "Split"],
		[Messages.HELP_BETINFO_BETTYPE_TRASV, "Trio"],
		[Messages.HELP_BETINFO_BETTYPE_CARRE, "Corner"],
		[Messages.HELP_BETINFO_BETTYPE_FIFTH, "Fünf Zahlen"],
		[Messages.HELP_BETINFO_BETTYPE_SIXTH, "Sechs Zahlen"],
		[Messages.HELP_BETINFO_BETTYPE_HLINE, "Horizontale Linie"],
		[Messages.HELP_BETINFO_BETTYPE_THIRD, "Dritter"],
		[Messages.HELP_BETINFO_BETTYPE_COLOR, "Rot / Schwarz"],
		[Messages.HELP_BETINFO_BETTYPE_ODEVN, "Ungerade / Gerade"],
		[Messages.HELP_BETINFO_BETTYPE_PHALF, "Halb"],
		[Messages.HELP_BETINFO_MIN_TABLE_BET, "Minimaler Tischeinsatz ist"],
		[Messages.HELP_BETINFO_MAX_TABLE_BET, "Der maximale Tischeinsatz ist"],
		[Messages.HELP_BETINFO_NO_MIN_TABLE_BET, "Tisch hat keinen Mindesteinsatz"],
		[Messages.HELP_BETINFO_NO_MAX_TABLE_BET, "Tisch hat keinen maximalen Einsatz"],
		[Messages.HELP_LAYOUT_BUTTON, "Umschalten zwischen Board- und Rennstreckenansicht durch Drücken der Layout-Schaltfläche."],
		[Messages.HELP_DISCONNECTION_POLICY, "Wenn Sie von einer Spielrunde getrennt werden, bleiben alle platzierten Wetten gültig und werden in Ihrer Abwesenheit abgerechnet. Wenn Sie wieder verbunden sind, können Sie die Wettergebnisse mit der Schaltfläche \"Verlauf\" anzeigen."],
		[Messages.HELP_ERROR_HANDLING, "Wenn es einen Fehler im Spiel, System oder Spielablauf gibt, wird die Spielrunde vorübergehend unterbrochen. Sie und andere Spieler werden per Chat im Spiel oder durch eine Popup-Nachricht auf dem Bildschirm benachrichtigt , dass das Problem untersucht wird. Wenn der Manager den Fehler sofort beheben kann, wird die Spielrunde normal fortgesetzt. Wenn eine sofortige Lösung nicht möglich ist, wird die Spielrunde abgebrochen und die anfänglichen Wetten werden allen teilnehmenden Spielern zurückerstattet in der Spielrunde."],
		[Messages.HELP_JACKPOT_LEVEL, "Die Jackpot-Anzeige zeigt alle verfügbaren Jackpot-Levels und Pot-Werte. Wenn ein Spiel für den Jackpot qualifiziert ist, zeigt die Jackpot-Anzeige nur das aktive Level."],
		[Messages.HELP_JACKPOT_MARKER, "Wenn eine ausgewählte Jackpot-Zahl aufgedeckt wird, wird sie auf dem Spielbrett markiert."],
		[Messages.GA_HELP_JACKPOT_LEVEL, "Die Jackpot-Anzeige zeigt alle verfügbaren Jackpot-Levels und Pot-Werte an. Wenn ein Spiel für den Jackpot qualifiziert ist, beginnt die spezifische Jackpot-Stufe zu leuchten."],
		[Messages.GA_HELP_JACKPOT_MARKER, "Wenn eine ausgewählte Jackpot-Zahl aufgedeckt wird, wird sie in der Glückszahlenanzeige markiert."],
		[Messages.PAYOUT_BUTTON, "Auszahlung"],
		[Messages.MENU_HISTORY, "Verlauf"],
		[Messages.MENU_STATISTICS, "Statistiken"],
		[Messages.MENU_FULLSCREEN, "Vollbild"],
		[Messages.MENU_CHAT, "Chat"],
		[Messages.MENU_VOLUME_SETTINGS, "Lautstärkeeinstellungen"],
		[Messages.MENU_GRAPHICS_SETTINGS, "Grafikeinstellungen"],
		[Messages.MENU_WITHDRAW, "Zurückziehen"],
		[Messages.MENU_LOGOUT, "Abmelden"],
		[Messages.SETTINGS_MUSIC_VOLUME, "Musiklautstärke"],
		[Messages.SETTINGS_EFFECTS_VOLUME, "Effektlautstärke"],
		[Messages.SETTINGS_VIDEO_VOLUME, "Videolautstärke"],
		[Messages.SETTINGS_RENDER, "Renderqualität"],
		[Messages.MIN_TABLE_BET, "Min-Einsatz"],
		[Messages.MAX_TABLE_BET, "Maximale Wette"],
		[Messages.TABLE_NO_MAXIMUM, "Keine Obergrenze"],
		[Messages.TABLE_NO_MINIMUM, "Kein Mindestlimit"],
		[Messages.BLACK_SNAKE, "BLACK SNAKE"],
		[Messages.NEIGHBORS, "NACHBARN"],
		[Messages.SMALL_SERIES, "KLEINE SERIE"],
		[Messages.ALTERNATIVE_ZERO_GAME, "0 SPIEL"],
		[Messages.CLEAR, "LÖSCHEN"],
		[Messages.CLEAR_ALL, "ALLE LÖSCHEN?"],
		[Messages.START, "START"],
		[Messages.PLACE_BETS_FOR_SHOWING_POTENTIAL_WINS, "Platzieren Sie einige Wetten, um potenzielle Gewinne anzuzeigen"],
		[Messages.SUCCESSFUL_LOGOUT_THANK_YOU, "Erfolgreich abgemeldet. Danke fürs Spielen!"],
		[Messages.SELECT_STAKE_TO_PLAY, "Wählen Sie den Einsatz, mit dem Sie spielen möchten"],
		[Messages.CONTINUE_BUTTON, "Weiter"],
		[Messages.GENERIC_GAME, "SPIEL"],
		[Messages.TRACK_BIG_SERIES, "GROSSE SERIE"],
		[Messages.HANDPAY_LOCK_INFO_PLAYER_NAME, "Spielername"],
		[Messages.HANDPAY_LOCK_INFO_PLAYER_NICKNAME, "Spielername"],
		[Messages.HANDPAY_LOCK_INFO_STATION_OR_DOMAIN, "Am Bahnhof"],
		[Messages.PAYOUT_REQUEST_ARE_YOU_SURE, "Sind Sie sicher, dass Sie die\nAuszahlung von anfordern möchten"],
		[Messages.CLICK_TO_CLOSE_HISTORY_VIEW, "Klicken Sie irgendwo, um die Verlaufsansicht zu schließen"],
		[Messages.QUESTION_STAKE_DESCRIPTION_SUBTEXT, "Limits für Straight\nUp-Wetten"],
		[Messages.QUESTION_STAKE, "Einsatz"],
		[Messages.INTRO_HOW_TO_PLAY, "Spielanleitung:"],
		[Messages.INTRO_HOW_TO_PLAY_DESCRIPTION, "Wählen Sie Ihren Wettchip durch Anklicken aus, platzieren Sie ihn durch erneutes Anklicken der gewünschten Felder."],
		[Messages.BUTTON_HELP, "HILFE"],
		[Messages.BUTTON_LOCK, "SPERREN"],
		[Messages.BUTTON_DENOMINATION, "DENOM."],
		[Messages.CLOSING, "Schließen..."],
		[Messages.CLICK_LES_FIGURES, "CLICK LES FIGURES"],
		[Messages.CLICK_SIMPLE_SIDEBETS, "CLICK SIDEBETS"],
		[Messages.LESFIGURES_NASSA, "NASSA"],
		[Messages.LESFIGURES_ORPHELINS, "ORPHELINS"],
		[Messages.LESFIGURES_TIER, "TIER"],
		[Messages.LESFIGURES_VOISINS, "VOISINS"],
		[Messages.LESFIGURES_COLLECT, "ZURÜCKZIEHEN"],
		[Messages.LESFIGURES_ALLIN, "AKTIVIEREN\nSIE ALLES"],
		[Messages.HELP_BETINFO_BETTYPE_FIGURE, "Figure"],
		[Messages.HELP_BETINFO_BETTYPE_TAUTVA, "All In"],
		[Messages.HELP_FIGURES_FIGURE_DESCRIPTION, "Inside each figure there are numbers the sidebet covers.\n\n\"Figure 1\" covers: 1,10,19 and 28.\n\"Figure 2\" covers: 2,11,20 and 29.\n\"Figure 3\" covers: 3,12,21 and 30.\n\"Figure 4\" covers: 4,13,22 and 31.\n\"Figure 5\" covers: 5,14,23 and 32.\n\"Figure 6\" covers: 6,15,24 and 33.\n\"Figure 7\" covers: 7,16,25 and 34.\n\"Figure 8\" covers: 8,17,26 and 35.\n\"Figure 9\" covers: 9,18,27 and 36."],
		[Messages.HELP_FIGURES_FIGURE_WIN, "In case of a winning hand on the figures sidebets, players can choose between collecting the winning bet or activate the game option \"All In\". In the game \"All In\", the chips are moved to the upper box of the last winning figure. Upon inaction collect is automatically selected."],
		[Messages.HELP_FIGURES_TOUTVA_DESCRIPTION, "If the \"All In\" bet is still winning it will pay "],
		[Messages.HELP_FIGURES_TOUTVA_DESCRIPTION_SECONDPART, " - the player will win extra chips compared to regular figures bet that pays "],
	]);
	private static FranceTranslation: Map<Messages, string> = new Map<Messages, string>([
		[Messages.WAITING, "En attendant..."],
		[Messages.BETS_OPEN_PLACE_BETS, "Les paris sont ouverts, placez vos paris"],
		[Messages.BETS_CLOSING_HURRY, "Les paris se clôturent, dépêchez-vous!"],
		[Messages.NO_MORE_BETS, "Rien ne va plus"],
		[Messages.WAITING_WIN_NUMBER, "En attente du numéro gagnant..."],
		[Messages.DISCONNECTED, "Déconnecté, reconnecté..."],
		[Messages.BET, "Pari"],
		[Messages.WIN, "Dernière victoire"],
		[Messages.BETS_ARE_CLOSED, "Attendez le prochain match."],
		[Messages.NOT_ENOUGH_CREDITS, "Vous n'avez pas assez de crédits."],
		[Messages.MAX_NUM_CHIPS_REACHED, "Nombre maximum de jetons atteint!"],
		[Messages.PLAYBOARD_LIMIT_REACHED, "Limite de plateau de jeu atteinte!"],
		[Messages.MAX_WIN_LIMIT_REACHED, "Limite maximale de gains atteinte!"],
		[Messages.MAX_BET_LIMIT_REACHED, "Limite de pari maximale atteinte!"],
		[Messages.LEFT_REDS, "GAUCHE ROUGES"],
		[Messages.LEFT_BLACKS, "GAUCHE NOIRS"],
		[Messages.RIGHT_REDS, "DROITS ROUGES"],
		[Messages.RIGHT_BLACKS, "DROITS NOIRS"],
		[Messages.NEIGBOR_BET, "PARI DU VOISIN"],
		[Messages.TABLE_LAYOUT, "DISPOSITION DU TABLEAU"],
		[Messages.REPEAT, "RÉPÉTER"],
		[Messages.UNDO, "ANNULER"],
		[Messages.ZERO_GAME, "JEU ZÉRO"],
		[Messages.BIG_SERIES, "GRANDE SÉRIE"],
		[Messages.ORPHANS, "ORPHELINS"],
		[Messages.SERIE_58, "SÉRIE 5/8"],
		[Messages.FINALI, "FINALE"],
		[Messages.RED_SPLIT, "SPLIT ROUGE"],
		[Messages.BLACK_SPLIT, "SPLIT NOIR"],
		[Messages.HOT_NUMBERS, "NUMÉROS CHAUDS"],
		[Messages.RED_SNAKE, "SERPENT ROUGE"],
		[Messages.PRISON_BETS, "PARIS EN PRISON"],
		[Messages.MAGIC_RING, "BAGUE MAGIQUE"],
		[Messages.COLD_NUMBERS, "NUMÉROS FROID"],
		[Messages.TRACK_LAYOUT, "DISPOSITION DES PISTES"],
		[Messages.PRESETS, "PRÉRÉGLAGES DE PARI"],
		[Messages.WRONG_BET, "Mauvais pari"],
		[Messages.ERROR_ESTABLISHING_CONNECTION, "Erreur lors de l'établissement de la connexion au serveur!"],
		[Messages.INCOMPATIBLE_BET, "Pari incompatible, ne peut pas passer à"],
		[Messages.TO_TABLE_LAYOUT, "disposition du tableau."],
		[Messages.TO_TRACK_LAYOUT, "disposition des pistes."],
		[Messages.CHANGE_TO_BOARD_LAYOUT_TO_BET, "Veuillez changer la disposition du tableau pour effectuer le pari."],
		[Messages.WINNING_NUMBER_IS, "Le numéro gagnant est"],
		[Messages.TURN_DEVICE_HORIZONTALLY, "Veuillez tourner l'appareil horizontalement!"],
		[Messages.CANNOT_REACH_SERVER_AT, "Impossible d'atteindre le serveur à"],
		[Messages.BANNED_TRY_AGAIN, "Impossible de se connecter pour le moment. Réessayez dans une minute!"],
		[Messages.BETS_NOT_COMMITED, "Les paris n'ont pas été engagés à temps!"],
		[Messages.CONNECTING, "De liaison..."],
		[Messages.DOUBLE, "DOUBLE"],
		[Messages.CANNOT_SHOW_HISTORY, "Impossible d'afficher l'historique dans un jeu actif!"],
		[Messages.NO_PLAYED_GAME_HISTORY, "Aucun jeu joué à afficher dans l'historique!"],
		[Messages.SHOWING_HISTORY, "Affichage de l'historique du jeu :"],
		[Messages.ERROR_MISSING_PARAM, "ERREUR : Paramètre(s) manquant(s)!"],
		[Messages.GAME_ID, "Identifiant de jeu"],
		[Messages.PLAYER_ID, "Identifiant du joueur"],
		[Messages.CASH, "En espèces"],
		[Messages.CREDIT, "Crédit"],
		[Messages.PAINT, "PEINTURE"],
		[Messages.NORMAL, "ORDINAIRE"],
		[Messages.ONE_CREDIT, "1 crédit"],
		[Messages.DEMO, "DÉMO"],
		[Messages.MALFUNCTION_VOID_WARNING, "Un dysfonctionnement annule tous les jeux et paie!"],
		[Messages.ERROR_ESTABLISHING_CONNECTION_RETRY, "Erreur lors de l'établissement de la connexion! Nouvelle tentative..."],
		[Messages.YOU_HAVE_PLACED_BETS, "Vous avez placé des paris!"],
		[Messages.ACCOUNT_ALREADY_CONNECTED, "Compte déjà connecté! Nouvelle tentative..."],
		[Messages.ENTER_PIN, "ENTREZ VOTRE NIP"],
		[Messages.CLIENT_LOCKED, "CLIENT VERROUILLÉ"],
		[Messages.PRESS_LOGOUT_AGAIN_TO_LOGOUT, "Appuyez à nouveau sur le bouton de déconnexion pour confirmer la déconnexion"],
		[Messages.CANNOT_LOGOUT_ACTIVE_GAME, "Impossible de se déconnecter d'un jeu actif!"],
		[Messages.WRONG_PASSWORD, "Mauvais mot de passe!"],
		[Messages.HOW_TO_ENTER_FULLSCREEN, "Comment entrer en plein écran :"],
		[Messages.CLICK_TO_CONTINUE, "Cliquez n'importe où pour continuer"],
		[Messages.ENABLE_SOUNDS, "Jouer des sons ?"],
		[Messages.YES, "Oui"],
		[Messages.NO, "Non"],
		[Messages.GAMES_AGO, "joué à des jeux il y a"],
		[Messages.AUTHENTICATION_PROBLEM, "Problème d'authentification"],
		[Messages.GO_TO_CASHIER, "Passez à la caisse pour le paiement..."],
		[Messages.FIELD_LIMIT, "Limite de champ atteinte!"],
		[Messages.NO_GAME_TO_REPEAT, "Aucun jeu joué à répéter!"],
		[Messages.CLICK_TO_RESTART_GAME, "CLIQUEZ ICI POUR REDÉMARRER LE JEU"],
		[Messages.REPEAT_THIS_GAME, "RÉPÉTER SÉLECTIONNÉ"],
		[Messages.CANNOT_REPEAT_SELECTED_GAME, "Impossible de répéter le jeu sélectionné!"],
		[Messages.I_ACCEPT, "J'accepte"],
		[Messages.ACCEPT_TERMS_CONDITIONS, "En jouant à ce jeu, vous acceptez nos termes et conditions"],
		[Messages.CLICK_TO_CHAT, "CLIQUEZ POUR CHATER"],
		[Messages.X_PLAYERS_WON, "A GAGNÉ"],
		[Messages.CHANGING_CROUPIER, "Changer de croupier, merci d'avoir joué!"],
		[Messages.SESSION_TIMED_OUT_RESTART_CLIENT, "Votre session s'est terminée pour cause d'inactivité,\n veuillez redémarrer le jeu pour continuer à jouer!"],
		[Messages.CONNECTION_IS_BAD, "VOTRE CONNEXION INTERNET EST MAUVAISE"],
		[Messages.ANDROID_PRE_FULLSCREEN_MESSAGE, "APPUYEZ SUR OK POUR ENTRER EN PLEIN ÉCRAN"],
		[Messages.DESKTOP_PRE_FULLSCREEN_MESSAGE, "JOUER EN MODE PLEIN ECRAN ?"],
		[Messages.SET_PIN, "DÉFINISSEZ VOTRE CODE PIN"],
		[Messages.SET_PIN_SUBTEXT, "Vous serez invité à entrer le code PIN lors du paiement."],
		[Messages.CONFIRM_PIN, "CONFIRMER LE NIP"],
		[Messages.CONFIRM_PIN_SUBTEXT, "Veuillez ressaisir votre NIP."],
		[Messages.ENTER_PIN_SUBTEXT, "Veuillez saisir votre code PIN d'authentification."],
		[Messages.PAYOUT_REQUESTED, "PAIEMENT DEMANDÉ"],
		[Messages.SESSION_EXPIRED, "Votre session a expiré,\n veuillez redémarrer le jeu!"],
		[Messages.DOUBLE_ZERO_GAME, "JEU DOUBLE ZÉRO"],
		[Messages.MAX_WIN, "GAIN MAXIMUM"],
		[Messages.LAST_BET, "DERNIER PARI"],
		[Messages.LAST_WIN, "DERNIÈRE VICTOIRE"],
		[Messages.ZERO_GAME_AND_BIG_SERIES, "ZÉRO JEU / GRANDE SÉRIE"],
		[Messages.NASSA_AND_BIG_SERIES, "NASSA / GRANDE SÉRIE"],
		[Messages.HISTORY_VIEW_TITLE, "VUE HISTORIQUE"],
		[Messages.TRACK_VIEW, "SUIVRE\nVOIR"],
		[Messages.TABLE_VIEW, "TABLE\nVUE"],
		[Messages.SHOW_WINS, "Afficher les gains"],
		[Messages.HIDE_WINS, "Masquer les gains"],
		[Messages.HISTORY_WIN, "Gagner"],
		[Messages.HELP_TITLE, "AIDER"],
		[Messages.HELP_PLAYER_INTERFACE, "Interface joueur"],
		[Messages.HELP_PLAYER_TRACK, "Piste du joueur"],
		[Messages.HELP_PLAYER_INFORMATION, "Informations sur le joueur"],
		[Messages.HELP_TOP_PANEL, "Panneau du haut"],
		[Messages.HELP_JACKPOT, "Cagnotte"],
		[Messages.HELP_FIGURES, "Figures"],
		[Messages.HELP_EXTRAS, "Suppléments"],
		[Messages.HELP_FIVE_NUMBERS_TITLE, "CINQ CHIFFRES"],
		[Messages.HELP_FIVE_NUMBERS_BODY, "Le numéro gagnant est l'un des cinq couverts."],
		[Messages.HELP_FOUR_NUMBERS_TITLE, "QUATRE NUMÉROS"],
		[Messages.HELP_FOUR_NUMBERS_BODY, "Le numéro gagnant est l'un des quatre couverts."],
		[Messages.HELP_TRIO_TITLE, "TRIO"],
		[Messages.HELP_TRIO_BODY, "Le numéro gagnant est l'un des trois couverts."],
		[Messages.HELP_SIX_NUMBERS_TITLE, "SIX NUMÉROS"],
		[Messages.HELP_SIX_NUMBERS_BODY, "Le numéro gagnant est l'un des six couverts."],
		[Messages.HELP_CORNER_TITLE, "COIN"],
		[Messages.HELP_CORNER_BODY, "Le numéro gagnant est l'un des quatre couverts."],
		[Messages.HELP_SPLIT_TITLE, "DIVISER"],
		[Messages.HELP_SPLIT_BODY, "Le numéro gagnant est l'un des deux couverts."],
		[Messages.HELP_STRAIGHT_TITLE, "DIRECTEMENT"],
		[Messages.HELP_STRAIGHT_BODY, "Le numéro gagnant est uniquement celui couvert."],
		[Messages.HELP_BLACK_RED, "Les champs 1-18, PAR, ROUGE, NOIR, IMPAR, 19-36 vous permettent de parier sur tous les numéros respectifs."],
		[Messages.HELP_1TO12, "Les tiers verticaux et horizontaux couvrent les nombres dans leurs lignes et colonnes respectives."],
		[Messages.HELP_REPEAT_BODY, "Vous pouvez répéter les paris de votre dernier jeu en appuyant sur REPEAT lorsque votre table est vide."],
		[Messages.HELP_UNDO_BODY, "En appuyant sur UNDO, vous pouvez revenir en arrière d'une étape. Par exemple, vous pouvez annuler votre dernier pari."],
		[Messages.HELP_BET_PRESETS_BODY, "En appuyant sur BET PRESETS, vous obtenez une large sélection de paris personnalisés."],
		[Messages.HELP_PROGRESS_BAR_BODY, "Temps restant jusqu'à la clôture des paris. La barre de temps vous indiquera l'heure des paris de clôture."],
		[Messages.HELP_PROGRESS_BAR_TEXT_BODY, "Message d'état du jeu. Lorsque vous jouez, différents messages vous indiqueront l'état du jeu."],
		[Messages.HELP_BUTTON_PRESETS_BODY, "Paris prédéfinis très populaires :\n”ZERO GAME” - placez des paris pour couvrir zéro numéro voisin dans une plage étroite, la série est : 12, 35, 3, 26, 0, 32, 15.\n”BIG SERIES” - placez paris pour couvrir zéro numéro voisin, la série est 0, 2, 19, 21, 22, 25, 3, 4, 26, 28, 29, 32, 35, 7, 12, 15, 18.\n”ORPHANS” - ce pari comporte des numéros, qui n'appartiennent ni à ”SERIE 5/8”, ni à ”BIG SERIES”, la série est : 14, 17, 20, 31, 34, 6, 9, 1.\n”SERIE 5/8” - ce pari comporte les 12 numéros situés du côté opposé de la roue à zéro unique, la série est : 27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33."],
		[Messages.HELP_HISTORY_BAR, "Gagnez l'historique des numéros de gauche à droite."],
		[Messages.HELP_PLAYER_CREDITS, "Affichage du solde du joueur avec les montants des mises et des derniers gains. En appuyant dessus, vous pouvez basculer entre les valeurs d'argent et de crédit."],
		[Messages.HELP_BETTING_CHIPS, "Jouer aux jetons."],
		[Messages.HELP_ERASER, "Utilisez la gomme pour enlever les puces placées. Appuyez trois fois pour supprimer tous les jetons placés."],
		[Messages.HELP_PLAYER_NAME_AND_DENOM, "Nom et dénomination du joueur."],
		[Messages.HELP_DENOMINATION, "Dénomination."],
		[Messages.HELP_PAYS, "paie"],
		[Messages.HELP_TRACK_FIELD, "Appuyez sur chaque numéro de la piste de course pour parier sur ce numéro avec la valeur du jeton sélectionné."],
		[Messages.HELP_TRACK_CHEVAL, "Appuyez sur le bouton cheval entre les numéros, pour placer un pari partagé sur les deux numéros voisins."],
		[Messages.HELP_TRACK_CENTER_PRESETS, "Les paris prédéfinis populaires sont désormais disponibles au centre de l'hippodrome."],
		[Messages.HELP_TRACK_WIDE_BETS, "En choisissant + 0, + 1, + 2, + 4, il est possible de définir la couverture des paris. Où +0 signifie uniquement le pari sélectionné, +1 couvre le pari sélectionné et un champ à gauche et un à droite, +2 deux champs supplémentaires de gauche à droite et +4 couvre quatre champs en largeur."],
		[Messages.HELP_BETINFO_TITLE, "Paris"],
		[Messages.HELP_BETINFO_DESCRIPTION, "Vous trouverez ci-dessous le tableau des limites actuelles par type de pari. Les valeurs indiquées sont en crédits!"],
		[Messages.HELP_BETINFO_MAIN_DESCRIPTION, ""],
		[Messages.HELP_BETINFO_CHIPS_DESCRIPTION, "Valeurs des jetons pour la mise actuellement sélectionnée"],
		[Messages.HELP_BETINFO_LIMITS_TABLE, "Tableau des limites"],
		[Messages.HELP_BETINFO_MIN_BET, "Pari minimum"],
		[Messages.HELP_BETINFO_MAX_BET, "Pari maximum"],
		[Messages.HELP_BETINFO_BET_TYPE, "Type de pari"],
		[Messages.HELP_BETINFO_BETTYPE_PLAIN, "Directement"],
		[Messages.HELP_BETINFO_BETTYPE_CAVAL, "Diviser"],
		[Messages.HELP_BETINFO_BETTYPE_TRASV, "Trio"],
		[Messages.HELP_BETINFO_BETTYPE_CARRE, "Coin"],
		[Messages.HELP_BETINFO_BETTYPE_FIFTH, "Cinq numéros"],
		[Messages.HELP_BETINFO_BETTYPE_SIXTH, "Six numéros"],
		[Messages.HELP_BETINFO_BETTYPE_HLINE, "Ligne horizontale"],
		[Messages.HELP_BETINFO_BETTYPE_THIRD, "Troisième"],
		[Messages.HELP_BETINFO_BETTYPE_COLOR, "Rouge / Noir"],
		[Messages.HELP_BETINFO_BETTYPE_ODEVN, "Impair / Pair"],
		[Messages.HELP_BETINFO_BETTYPE_PHALF, "Demi"],
		[Messages.HELP_BETINFO_MIN_TABLE_BET, "Le pari minimum de table est"],
		[Messages.HELP_BETINFO_MAX_TABLE_BET, "La mise maximale de table est"],
		[Messages.HELP_BETINFO_NO_MIN_TABLE_BET, "La table n'a pas de mise minimum"],
		[Messages.HELP_BETINFO_NO_MAX_TABLE_BET, "La table n'a pas de mise maximum"],
		[Messages.HELP_LAYOUT_BUTTON, "Basculez entre la vue du tableau et celle de l'hippodrome en appuyant sur le bouton de mise en page."],
		[Messages.HELP_DISCONNECTION_POLICY, "Si vous êtes déconnecté d'un tour de jeu, tous les paris placés restent valables et sont réglés en votre absence. Lors de la reconnexion, vous pouvez voir les résultats des paris avec le bouton historique."],
		[Messages.HELP_ERROR_HANDLING, "S'il y a une erreur dans le jeu, le système ou la procédure de jeu, le tour de jeu sera temporairement mis en pause. Vous et les autres joueurs serez avertis via le chat en jeu ou par un message contextuel à l'écran que le problème est en cours d'investigation. Si le manager peut immédiatement résoudre l'erreur, le tour de jeu se poursuivra normalement. Si une résolution immédiate n'est pas possible, le tour de jeu sera annulé et les paris initiaux seront remboursés à tous les joueurs qui ont participé au tour de jeu."],
		[Messages.HELP_JACKPOT_LEVEL, "L'affichage du jackpot affiche tous les niveaux de jackpot disponibles et les valeurs des pots. Si un jeu est éligible pour le jackpot, l'affichage du jackpot n'affichera que le niveau actif."],
		[Messages.HELP_JACKPOT_MARKER, "Lorsqu'un numéro de jackpot sélectionné est révélé, il sera marqué sur le tableau de jeu."],
		[Messages.GA_HELP_JACKPOT_LEVEL, "L'affichage du jackpot affiche tous les niveaux de jackpot disponibles et les valeurs des pots. Si un jeu est éligible au jackpot, le niveau de jackpot spécifique commencera à briller."],
		[Messages.GA_HELP_JACKPOT_MARKER, "Lorsqu'un numéro de jackpot sélectionné est révélé, il sera marqué à l'intérieur de l'affichage du numéro porte-bonheur."],
		[Messages.PAYOUT_BUTTON, "Paiement"],
		[Messages.MENU_HISTORY, "Histoire"],
		[Messages.MENU_STATISTICS, "Statistiques"],
		[Messages.MENU_FULLSCREEN, "Plein écran"],
		[Messages.MENU_CHAT, "Discuter"],
		[Messages.MENU_VOLUME_SETTINGS, "Paramètres de volume"],
		[Messages.MENU_GRAPHICS_SETTINGS, "Paramètres graphiques"],
		[Messages.MENU_WITHDRAW, "Retirer"],
		[Messages.MENU_LOGOUT, "Se déconnecter"],
		[Messages.SETTINGS_MUSIC_VOLUME, "Volume de la musique"],
		[Messages.SETTINGS_EFFECTS_VOLUME, "Volume des effets"],
		[Messages.SETTINGS_VIDEO_VOLUME, "Volume vidéo"],
		[Messages.SETTINGS_RENDER, "Qualité de rendu"],
		[Messages.MIN_TABLE_BET, "Pari minimum"],
		[Messages.MAX_TABLE_BET, "Pari maximum"],
		[Messages.TABLE_NO_MAXIMUM, "Pas de limite maximale"],
		[Messages.TABLE_NO_MINIMUM, "Aucune limite minimale"],
		[Messages.BLACK_SNAKE, "SERPENT NOIR"],
		[Messages.NEIGHBORS, "VOISINS"],
		[Messages.SMALL_SERIES, "PETITE SERIE"],
		[Messages.ALTERNATIVE_ZERO_GAME, "0 JEU"],
		[Messages.CLEAR, "DÉGAGER"],
		[Messages.CLEAR_ALL, "TOUT EFFACER?"],
		[Messages.START, "DÉBUT"],
		[Messages.PLACE_BETS_FOR_SHOWING_POTENTIAL_WINS, "Placez des paris pour montrer les gains potentiels"],
		[Messages.SUCCESSFUL_LOGOUT_THANK_YOU, "Déconnexion réussie. Merci d'avoir joué!"],
		[Messages.SELECT_STAKE_TO_PLAY, "Sélectionnez la mise avec laquelle vous voulez jouer"],
		[Messages.CONTINUE_BUTTON, "Continuez"],
		[Messages.GENERIC_GAME, "JEU"],
		[Messages.TRACK_BIG_SERIES, "GRANDE SÉRIE"],
		[Messages.HANDPAY_LOCK_INFO_PLAYER_NAME, "Nom de joueur"],
		[Messages.HANDPAY_LOCK_INFO_PLAYER_NICKNAME, "Pseudonyme du joueur"],
		[Messages.HANDPAY_LOCK_INFO_STATION_OR_DOMAIN, "A la gare"],
		[Messages.PAYOUT_REQUEST_ARE_YOU_SURE, "Êtes-vous sûr de vouloir\ndemander le paiement de"],
		[Messages.CLICK_TO_CLOSE_HISTORY_VIEW, "Cliquez n'importe où pour fermer la vue de l'historique"],
		[Messages.QUESTION_STAKE_DESCRIPTION_SUBTEXT, "limites pour les paris directs"],
		[Messages.QUESTION_STAKE, "Pieu"],
		[Messages.INTRO_HOW_TO_PLAY, "Comment jouer:"],
		[Messages.INTRO_HOW_TO_PLAY_DESCRIPTION, "Sélectionnez votre jeton de pari en cliquant, placez-le en cliquant à nouveau sur les champs souhaités."],
		[Messages.BUTTON_HELP, "AIDER"],
		[Messages.BUTTON_LOCK, "VERROUILLER"],
		[Messages.BUTTON_DENOMINATION, "DÉNOM."],
		[Messages.CLOSING, "Fermeture..."],
		[Messages.CLICK_LES_FIGURES, "CLICK LES FIGURES"],
		[Messages.CLICK_SIMPLE_SIDEBETS, "CLICK SIDEBETS"],
		[Messages.LESFIGURES_NASSA, "NASSA"],
		[Messages.LESFIGURES_ORPHELINS, "ORPHELINS"],
		[Messages.LESFIGURES_TIER, "TIER"],
		[Messages.LESFIGURES_VOISINS, "VOISINS"],
		[Messages.LESFIGURES_COLLECT, "RETIRER"],
		[Messages.LESFIGURES_ALLIN, "ACTIVER\nTOUT VA"],
		[Messages.HELP_BETINFO_BETTYPE_FIGURE, "Figure"],
		[Messages.HELP_BETINFO_BETTYPE_TAUTVA, "All In"],
		[Messages.HELP_FIGURES_FIGURE_DESCRIPTION, "Inside each figure there are numbers the sidebet covers.\n\n\"Figure 1\" covers: 1,10,19 and 28.\n\"Figure 2\" covers: 2,11,20 and 29.\n\"Figure 3\" covers: 3,12,21 and 30.\n\"Figure 4\" covers: 4,13,22 and 31.\n\"Figure 5\" covers: 5,14,23 and 32.\n\"Figure 6\" covers: 6,15,24 and 33.\n\"Figure 7\" covers: 7,16,25 and 34.\n\"Figure 8\" covers: 8,17,26 and 35.\n\"Figure 9\" covers: 9,18,27 and 36."],
		[Messages.HELP_FIGURES_FIGURE_WIN, "In case of a winning hand on the figures sidebets, players can choose between collecting the winning bet or activate the game option \"All In\". In the game \"All In\", the chips are moved to the upper box of the last winning figure. Upon inaction collect is automatically selected."],
		[Messages.HELP_FIGURES_TOUTVA_DESCRIPTION, "If the \"All In\" bet is still winning it will pay "],
		[Messages.HELP_FIGURES_TOUTVA_DESCRIPTION_SECONDPART, " - the player will win extra chips compared to regular figures bet that pays "],
	]);
	private static PortugeseTranslation: Map<Messages, string> = new Map<Messages, string>([
		[Messages.WAITING, "Esperando..."],
		[Messages.BETS_OPEN_PLACE_BETS, "As apostas estão abertas, faça suas apostas"],
		[Messages.BETS_CLOSING_HURRY, "As apostas estão fechando, apresse-se!"],
		[Messages.NO_MORE_BETS, "NÃO MAIS apostas"],
		[Messages.WAITING_WIN_NUMBER, "Aguardando o número da vitória..."],
		[Messages.DISCONNECTED, "Desconectado, reconectando..."],
		[Messages.BET, "Aposta"],
		[Messages.WIN, "Última vitória"],
		[Messages.BETS_ARE_CLOSED, "Aguarde o próximo jogo."],
		[Messages.NOT_ENOUGH_CREDITS, "Você não tem créditos suficientes."],
		[Messages.MAX_NUM_CHIPS_REACHED, "Número máximo de fichas atingido!"],
		[Messages.PLAYBOARD_LIMIT_REACHED, "Limite do playboard atingido!"],
		[Messages.MAX_WIN_LIMIT_REACHED, "Limite máximo de vitórias atingido!"],
		[Messages.MAX_BET_LIMIT_REACHED, "Limite máximo de aposta atingido!"],
		[Messages.LEFT_REDS, "VERMELHOS ESQUERDOS"],
		[Messages.LEFT_BLACKS, "PRETOS ESQUERDOS"],
		[Messages.RIGHT_REDS, "VERMELHOS DIREITOS"],
		[Messages.RIGHT_BLACKS, "PRETOS DIREITOS"],
		[Messages.NEIGBOR_BET, "APOSTA DO VIZINHO"],
		[Messages.TABLE_LAYOUT, "DISPOSIÇÃO DA TABELA"],
		[Messages.REPEAT, "REPITA"],
		[Messages.UNDO, "DESFAZER"],
		[Messages.ZERO_GAME, "ZERO JOGO"],
		[Messages.BIG_SERIES, "GRANDE SÉRIE"],
		[Messages.ORPHANS, "ÓRFÃOS"],
		[Messages.SERIE_58, "SÉRIE 5/8"],
		[Messages.FINALI, "FINAL"],
		[Messages.RED_SPLIT, "DIVISÃO VERMELHA"],
		[Messages.BLACK_SPLIT, "DIVISÃO PRETA"],
		[Messages.HOT_NUMBERS, "NÚMEROS QUENTES"],
		[Messages.RED_SNAKE, "SERPENTE VERMELHA"],
		[Messages.PRISON_BETS, "APOSTAS DE PRISÃO"],
		[Messages.MAGIC_RING, "ANEL MÁGICO"],
		[Messages.COLD_NUMBERS, "NÚMEROS FRIOS"],
		[Messages.TRACK_LAYOUT, "LAYOUT DE PISTA"],
		[Messages.PRESETS, "PRÉ-APOSTAS"],
		[Messages.WRONG_BET, "Aposta errada"],
		[Messages.ERROR_ESTABLISHING_CONNECTION, "Erro ao estabelecer conexão com o servidor!"],
		[Messages.INCOMPATIBLE_BET, "Aposta incompatível, não pode mudar para"],
		[Messages.TO_TABLE_LAYOUT, "disposição da mesa."],
		[Messages.TO_TRACK_LAYOUT, "disposição da pista."],
		[Messages.CHANGE_TO_BOARD_LAYOUT_TO_BET, "Por favor, mude para o layout do tabuleiro para realizar a aposta."],
		[Messages.WINNING_NUMBER_IS, "O número vencedor é"],
		[Messages.TURN_DEVICE_HORIZONTALLY, "Por favor, vire o dispositivo horizontalmente!"],
		[Messages.CANNOT_REACH_SERVER_AT, "Não é possível acessar o servidor em"],
		[Messages.BANNED_TRY_AGAIN, "Não é possível conectar agora. Tente novamente em um minuto!"],
		[Messages.BETS_NOT_COMMITED, "As apostas não foram confirmadas a tempo!"],
		[Messages.CONNECTING, "Conectando..."],
		[Messages.DOUBLE, "DUPLO"],
		[Messages.CANNOT_SHOW_HISTORY, "Não é possível mostrar o histórico em um jogo ativo!"],
		[Messages.NO_PLAYED_GAME_HISTORY, "Nenhum jogo jogado para ser mostrado como histórico!"],
		[Messages.SHOWING_HISTORY, "Mostrando o histórico do jogo:"],
		[Messages.ERROR_MISSING_PARAM, "ERRO: Parâmetro(s) ausente(s)!"],
		[Messages.GAME_ID, "ID do jogo"],
		[Messages.PLAYER_ID, "ID do jogador"],
		[Messages.CASH, "Dinheiro"],
		[Messages.CREDIT, "Crédito"],
		[Messages.PAINT, "PINTAR"],
		[Messages.NORMAL, "NORMAL"],
		[Messages.ONE_CREDIT, "1 crédito"],
		[Messages.DEMO, "DEMO"],
		[Messages.MALFUNCTION_VOID_WARNING, "O mau funcionamento anula todas as jogadas e pagamentos!"],
		[Messages.ERROR_ESTABLISHING_CONNECTION_RETRY, "Erro ao estabelecer conexão! Tentando novamente..."],
		[Messages.YOU_HAVE_PLACED_BETS, "Você fez apostas!"],
		[Messages.ACCOUNT_ALREADY_CONNECTED, "Conta já conectada! Tentando novamente..."],
		[Messages.ENTER_PIN, "INSIRA SEU PIN"],
		[Messages.CLIENT_LOCKED, "CLIENTE BLOQUEADO"],
		[Messages.PRESS_LOGOUT_AGAIN_TO_LOGOUT, "Pressione o botão de logout novamente para confirmar o logout"],
		[Messages.CANNOT_LOGOUT_ACTIVE_GAME, "Não é possível sair de um jogo ativo!"],
		[Messages.WRONG_PASSWORD, "Senha incorreta!"],
		[Messages.HOW_TO_ENTER_FULLSCREEN, "Como entrar em tela cheia:"],
		[Messages.CLICK_TO_CONTINUE, "Clique em qualquer lugar para continuar"],
		[Messages.ENABLE_SOUNDS, "Tocar sons?"],
		[Messages.YES, "sim"],
		[Messages.NO, "Não"],
		[Messages.GAMES_AGO, "jogos jogados atrás"],
		[Messages.AUTHENTICATION_PROBLEM, "Problema de autenticação"],
		[Messages.GO_TO_CASHIER, "Vá ao caixa para pagar..."],
		[Messages.FIELD_LIMIT, "Limite de campo atingido!"],
		[Messages.NO_GAME_TO_REPEAT, "Nenhum jogo jogado para repetir!"],
		[Messages.CLICK_TO_RESTART_GAME, "CLIQUE AQUI PARA REINICIAR O JOGO"],
		[Messages.REPEAT_THIS_GAME, "REPETIR SELECIONADO"],
		[Messages.CANNOT_REPEAT_SELECTED_GAME, "Não é possível repetir o jogo selecionado!"],
		[Messages.I_ACCEPT, "aceito"],
		[Messages.ACCEPT_TERMS_CONDITIONS, "Ao jogar este jogo você aceita nossos termos e condições"],
		[Messages.CLICK_TO_CHAT, "CLIQUE PARA CONVERSAR"],
		[Messages.X_PLAYERS_WON, "GANHOU"],
		[Messages.CHANGING_CROUPIER, "Mudando o crupiê, obrigado por jogar!"],
		[Messages.SESSION_TIMED_OUT_RESTART_CLIENT, "Sua sessão foi encerrada devido à inatividade.\n reinicie o jogo para continuar jogando!"],
		[Messages.CONNECTION_IS_BAD, "SUA CONEXÃO COM A INTERNET ESTÁ RUIM"],
		[Messages.ANDROID_PRE_FULLSCREEN_MESSAGE, "PRESSIONE OK PARA ENTRAR EM TELA CHEIA"],
		[Messages.DESKTOP_PRE_FULLSCREEN_MESSAGE, "JOGAR NO MODO DE TELA CHEIA?"],
		[Messages.SET_PIN, "DEFINIR O SEU CÓDIGO PIN"],
		[Messages.SET_PIN_SUBTEXT, "Você será solicitado a inserir o PIN no pagamento."],
		[Messages.CONFIRM_PIN, "CONFIRMAR PIN"],
		[Messages.CONFIRM_PIN_SUBTEXT, "Por favor, reinsira o seu PIN."],
		[Messages.ENTER_PIN_SUBTEXT, "Insira seu PIN de autenticação."],
		[Messages.PAYOUT_REQUESTED, "PAGAMENTO SOLICITADO"],
		[Messages.SESSION_EXPIRED, "Sua sessão expirou.\n reinicie o jogo!"],
		[Messages.DOUBLE_ZERO_GAME, "JOGO DUPLO ZERO"],
		[Messages.MAX_WIN, "GANHO MÁXIMO"],
		[Messages.LAST_BET, "ÚLTIMA APOSTA"],
		[Messages.LAST_WIN, "ÚLTIMA VITÓRIA"],
		[Messages.ZERO_GAME_AND_BIG_SERIES, "JOGO ZERO / SÉRIE GRANDE"],
		[Messages.NASSA_AND_BIG_SERIES, "NASSA / SÉRIE GRANDE"],
		[Messages.HISTORY_VIEW_TITLE, "VISUALIZAÇÃO DO HISTÓRICO"],
		[Messages.TRACK_VIEW, "FAIXA\nVER"],
		[Messages.TABLE_VIEW, "TABELA\nVER"],
		[Messages.SHOW_WINS, "Mostrar vitórias"],
		[Messages.HIDE_WINS, "Ocultar vitórias"],
		[Messages.HISTORY_WIN, "Ganhar"],
		[Messages.HELP_TITLE, "AJUDA"],
		[Messages.HELP_PLAYER_INTERFACE, "Interface do jogador"],
		[Messages.HELP_PLAYER_TRACK, "Faixa do jogador"],
		[Messages.HELP_PLAYER_INFORMATION, "Informações do jogador"],
		[Messages.HELP_TOP_PANEL, "Painel superior"],
		[Messages.HELP_JACKPOT, "Jackpot"],
		[Messages.HELP_FIGURES, "Figures"],
		[Messages.HELP_EXTRAS, "Extras"],
		[Messages.HELP_FIVE_NUMBERS_TITLE, "CINCO NÚMEROS"],
		[Messages.HELP_FIVE_NUMBERS_BODY, "O número vencedor é qualquer um dos cinco cobertos."],
		[Messages.HELP_FOUR_NUMBERS_TITLE, "QUATRO NÚMEROS"],
		[Messages.HELP_FOUR_NUMBERS_BODY, "O número vencedor é qualquer um dos quatro cobertos."],
		[Messages.HELP_TRIO_TITLE, "TRIO"],
		[Messages.HELP_TRIO_BODY, "O número vencedor é qualquer um dos três cobertos."],
		[Messages.HELP_SIX_NUMBERS_TITLE, "SEIS NÚMEROS"],
		[Messages.HELP_SIX_NUMBERS_BODY, "O número vencedor é qualquer um dos seis cobertos."],
		[Messages.HELP_CORNER_TITLE, "CORNER"],
		[Messages.HELP_CORNER_BODY, "O número vencedor é qualquer um dos quatro cobertos."],
		[Messages.HELP_SPLIT_TITLE, "SPLIT"],
		[Messages.HELP_SPLIT_BODY, "O número vencedor é qualquer um dos dois cobertos."],
		[Messages.HELP_STRAIGHT_TITLE, "STRAIGHT UP"],
		[Messages.HELP_STRAIGHT_BODY, "O número vencedor é apenas aquele coberto."],
		[Messages.HELP_BLACK_RED, "Os campos 1-18, PAR, VERMELHO, PRETO, IMPAR, 19-36 permitem apostar em todos os respectivos números."],
		[Messages.HELP_1TO12, "Terços verticais e horizontais cobrem números em suas respectivas linhas e colunas."],
		[Messages.HELP_REPEAT_BODY, "Você pode repetir as apostas do seu último jogo pressionando REPEAT quando sua mesa estiver vazia."],
		[Messages.HELP_UNDO_BODY, "Ao pressionar UNDO, você pode voltar um passo. Por exemplo, você pode desfazer sua última aposta."],
		[Messages.HELP_BET_PRESETS_BODY, "Ao pressionar BET PRESETS, você obtém uma ampla seleção de apostas personalizadas."],
		[Messages.HELP_PROGRESS_BAR_BODY, "Tempo restante até o fechamento das apostas. A barra de tempo mostrará a hora das apostas de fechamento."],
		[Messages.HELP_PROGRESS_BAR_TEXT_BODY, "Mensagem de status do jogo. Quando você joga, mensagens diferentes mostrarão o status do jogo."],
		[Messages.HELP_BUTTON_PRESETS_BODY, "Apostas predefinidas muito populares:\n”0 JOGO” - faça apostas para cobrir zero números vizinhos em um intervalo estreito, a série é: 12, 35, 3, 26, 0, 32, 15.\n”GRANDE SÉRIE” - coloque apostas para cobrir zero números vizinhos, a série é 0, 2, 19, 21, 22, 25, 3, 4, 26, 28, 29, 32, 35, 7, 12, 15, 18.\n”ÓRFÃOS” - esta aposta apresenta números que não pertencem nem à ”SÉRIE 5/8”, nem à ”GRANDE SÉRIE”, a série é: 14, 17, 20, 31, 34, 6, 9, 1.\n”SÉRIE 5/8 ” - esta aposta apresenta os 12 números localizados no lado oposto da roda de zero simples, a série é: 27, 13, 36, 11, 30, 8, 23, 10, 5, 24, 16, 33."],
		[Messages.HELP_HISTORY_BAR, "Ganhe histórico de números da esquerda para a direita."],
		[Messages.HELP_PLAYER_CREDITS, "Exibição do saldo do jogador com os valores da aposta e da última vitória. Ao pressioná-lo, você pode alternar entre valores de dinheiro e crédito."],
		[Messages.HELP_BETTING_CHIPS, "Jogando fichas."],
		[Messages.HELP_ERASER, "Use a borracha para remover as fichas colocadas. Toque três vezes para remover todas as fichas colocadas."],
		[Messages.HELP_PLAYER_NAME_AND_DENOM, "Nome do jogador e denominação."],
		[Messages.HELP_DENOMINATION, "Denominação."],
		[Messages.HELP_PAYS, "paga"],
		[Messages.HELP_TRACK_FIELD, "Pressione cada número na pista de corrida para apostar naquele número com o valor da ficha selecionado."],
		[Messages.HELP_TRACK_CHEVAL, "Pressione o botão cheval entre os números, para fazer uma aposta dividida em ambos os números vizinhos."],
		[Messages.HELP_TRACK_CENTER_PRESETS, "Apostas predefinidas populares estão agora disponíveis no centro da pista."],
		[Messages.HELP_TRACK_WIDE_BETS, "Ao escolher + 0, + 1, + 2, + 4 é possível definir a cobertura das apostas. Onde +0 significa apenas a aposta selecionada, +1 cobre a aposta selecionada e um campo à esquerda e um à direita, +2 mais dois campos à esquerda à direita e +4 cobre quatro campos de largura."],
		[Messages.HELP_BETINFO_TITLE, "Apostas"],
		[Messages.HELP_BETINFO_DESCRIPTION, "Abaixo está a tabela de limites atuais por tipo de aposta. Os valores listados estão em créditos!"],
		[Messages.HELP_BETINFO_MAIN_DESCRIPTION, ""],
		[Messages.HELP_BETINFO_CHIPS_DESCRIPTION, "Valores de fichas para a aposta atualmente selecionada"],
		[Messages.HELP_BETINFO_LIMITS_TABLE, "Tabela de limites"],
		[Messages.HELP_BETINFO_MIN_BET, "Aposta mínima"],
		[Messages.HELP_BETINFO_MAX_BET, "aposta máxima"],
		[Messages.HELP_BETINFO_BET_TYPE, "Tipo de aposta"],
		[Messages.HELP_BETINFO_BETTYPE_PLAIN, "Straight up"],
		[Messages.HELP_BETINFO_BETTYPE_CAVAL, "Split"],
		[Messages.HELP_BETINFO_BETTYPE_TRASV, "Trio"],
		[Messages.HELP_BETINFO_BETTYPE_CARRE, "Corner"],
		[Messages.HELP_BETINFO_BETTYPE_FIFTH, "Cinco números"],
		[Messages.HELP_BETINFO_BETTYPE_SIXTH, "Seis números"],
		[Messages.HELP_BETINFO_BETTYPE_HLINE, "Linha horizontal"],
		[Messages.HELP_BETINFO_BETTYPE_THIRD, "Terceiro"],
		[Messages.HELP_BETINFO_BETTYPE_COLOR, "Vermelho preto"],
		[Messages.HELP_BETINFO_BETTYPE_ODEVN, "Ímpar Par"],
		[Messages.HELP_BETINFO_BETTYPE_PHALF, "Metade"],
		[Messages.HELP_BETINFO_MIN_TABLE_BET, "A aposta mínima da mesa é"],
		[Messages.HELP_BETINFO_MAX_TABLE_BET, "A aposta máxima da mesa é"],
		[Messages.HELP_BETINFO_NO_MIN_TABLE_BET, "A mesa não tem aposta mínima"],
		[Messages.HELP_BETINFO_NO_MAX_TABLE_BET, "A mesa não tem aposta máxima"],
		[Messages.HELP_LAYOUT_BUTTON, "Alterne entre a visualização da prancha e da pista pressionando o botão de layout."],
		[Messages.HELP_DISCONNECTION_POLICY, "Se você for desconectado de uma rodada de jogo, todas as apostas feitas permanecerão válidas e serão liquidadas na sua ausência. Ao reconectar, você pode visualizar os resultados das apostas com o botão de histórico."],
		[Messages.HELP_ERROR_HANDLING, "Se houver um erro no jogo, sistema ou procedimento do jogo, a rodada do jogo será pausada temporariamente. Você e outros jogadores serão notificados por meio de bate-papo no jogo ou por uma mensagem pop-up na tela de que o problema está sendo investigado. Se o gerente puder resolver o erro imediatamente, a rodada do jogo continuará normalmente. Se a resolução imediata não for possível, a rodada do jogo será cancelada e as apostas iniciais serão reembolsadas a todos os jogadores que participaram da rodada."],
		[Messages.HELP_JACKPOT_LEVEL, "A tela de jackpot mostra todos os níveis de jackpot e valores de pote disponíveis. Se um jogo for elegível para o jackpot, a exibição do jackpot mostrará apenas o nível ativo."],
		[Messages.HELP_JACKPOT_MARKER, "Quando um número de jackpot selecionado é revelado, ele será marcado no playboard."],
		[Messages.GA_HELP_JACKPOT_LEVEL, "A tela de jackpot mostra todos os níveis de jackpot e valores de pote disponíveis. Se um jogo for elegível para o jackpot, o nível do jackpot específico começará a brilhar."],
		[Messages.GA_HELP_JACKPOT_MARKER, "Quando um número de jackpot selecionado é revelado, ele será marcado dentro da exibição do número da sorte."],
		[Messages.PAYOUT_BUTTON, "Pagamento"],
		[Messages.MENU_HISTORY, "História"],
		[Messages.MENU_STATISTICS, "Estatisticas"],
		[Messages.MENU_FULLSCREEN, "Tela cheia"],
		[Messages.MENU_CHAT, "Bate-papo"],
		[Messages.MENU_VOLUME_SETTINGS, "Configurações de volume"],
		[Messages.MENU_GRAPHICS_SETTINGS, "Configurações gráficas"],
		[Messages.MENU_WITHDRAW, "Retirar"],
		[Messages.MENU_LOGOUT, "Sair"],
		[Messages.SETTINGS_MUSIC_VOLUME, "Volume da música"],
		[Messages.SETTINGS_EFFECTS_VOLUME, "Volume de efeitos"],
		[Messages.SETTINGS_VIDEO_VOLUME, "Volume do vídeo"],
		[Messages.SETTINGS_RENDER, "Qualidade de renderização"],
		[Messages.MIN_TABLE_BET, "Aposta mínima"],
		[Messages.MAX_TABLE_BET, "Aposta máxima"],
		[Messages.TABLE_NO_MAXIMUM, "Sem limite máximo"],
		[Messages.TABLE_NO_MINIMUM, "Sem limite mínimo"],
		[Messages.BLACK_SNAKE, "COBRA NEGRA"],
		[Messages.NEIGHBORS, "VIZINHOS"],
		[Messages.SMALL_SERIES, "SÉRIE PEQUENA"],
		[Messages.ALTERNATIVE_ZERO_GAME, "0 JOGO"],
		[Messages.CLEAR, "LIMPAR"],
		[Messages.CLEAR_ALL, "LIMPAR TUDO?"],
		[Messages.START, "COMEÇAR"],
		[Messages.PLACE_BETS_FOR_SHOWING_POTENTIAL_WINS, "Faça algumas apostas para mostrar ganhos potenciais"],
		[Messages.SUCCESSFUL_LOGOUT_THANK_YOU, "Desconectado com sucesso. Obrigado por jogar!"],
		[Messages.SELECT_STAKE_TO_PLAY, "Selecione a aposta com a qual deseja jogar"],
		[Messages.CONTINUE_BUTTON, "Continuar"],
		[Messages.GENERIC_GAME, "JOGOS"],
		[Messages.TRACK_BIG_SERIES, "GRANDE SÉRIE"],
		[Messages.HANDPAY_LOCK_INFO_PLAYER_NAME, "Nome do jogador"],
		[Messages.HANDPAY_LOCK_INFO_PLAYER_NICKNAME, "Apelido do jogador"],
		[Messages.HANDPAY_LOCK_INFO_STATION_OR_DOMAIN, "Na estação"],
		[Messages.PAYOUT_REQUEST_ARE_YOU_SURE, "Tem certeza de que deseja\nsolicitar o pagamento de"],
		[Messages.CLICK_TO_CLOSE_HISTORY_VIEW, "Clique em qualquer lugar para fechar a visualização do histórico"],
		[Messages.QUESTION_STAKE_DESCRIPTION_SUBTEXT, "limites para apostas diretas\nup"],
		[Messages.QUESTION_STAKE, "Estaca"],
		[Messages.INTRO_HOW_TO_PLAY, "Como jogar:"],
		[Messages.INTRO_HOW_TO_PLAY_DESCRIPTION, "Selecione sua ficha de aposta clicando, coloque-a clicando novamente nos campos desejados. "],
		[Messages.BUTTON_HELP, "AJUDA"],
		[Messages.BUTTON_LOCK, "TRANCAR"],
		[Messages.BUTTON_DENOMINATION, "DENOM."],
		[Messages.CLOSING, "Fechamento..."],
		[Messages.CLICK_LES_FIGURES, "CLICK LES FIGURES"],
		[Messages.CLICK_SIMPLE_SIDEBETS, "CLICK SIDEBETS"],
		[Messages.LESFIGURES_NASSA, "NASSA"],
		[Messages.LESFIGURES_ORPHELINS, "ORPHELINS"],
		[Messages.LESFIGURES_TIER, "TIER"],
		[Messages.LESFIGURES_VOISINS, "VOISINS"],
		[Messages.LESFIGURES_COLLECT, "RETIRAR"],
		[Messages.LESFIGURES_ALLIN, "ATIVAR\nTUDO EM"],
		[Messages.HELP_BETINFO_BETTYPE_FIGURE, "Figure"],
		[Messages.HELP_BETINFO_BETTYPE_TAUTVA, "All In"],
		[Messages.HELP_FIGURES_FIGURE_DESCRIPTION, "Inside each figure there are numbers the sidebet covers.\n\n\"Figure 1\" covers: 1,10,19 and 28.\n\"Figure 2\" covers: 2,11,20 and 29.\n\"Figure 3\" covers: 3,12,21 and 30.\n\"Figure 4\" covers: 4,13,22 and 31.\n\"Figure 5\" covers: 5,14,23 and 32.\n\"Figure 6\" covers: 6,15,24 and 33.\n\"Figure 7\" covers: 7,16,25 and 34.\n\"Figure 8\" covers: 8,17,26 and 35.\n\"Figure 9\" covers: 9,18,27 and 36."],
		[Messages.HELP_FIGURES_FIGURE_WIN, "In case of a winning hand on the figures sidebets, players can choose between collecting the winning bet or activate the game option \"All In\". In the game \"All In\", the chips are moved to the upper box of the last winning figure. Upon inaction collect is automatically selected."],
		[Messages.HELP_FIGURES_TOUTVA_DESCRIPTION, "If the \"All In\" bet is still winning it will pay "],
		[Messages.HELP_FIGURES_TOUTVA_DESCRIPTION_SECONDPART, " - the player will win extra chips compared to regular figures bet that pays "],
	]);
}